

const $29dbe5dc0c1244c4$export$2105e595f0c02dae = (poi_ID)=>{
    return (0, $7dc86ea3d04f3d15$export$f965ae91e38a1274).find((poi)=>poi.id === poi_ID);
};




function $6b4070ff9ee527a8$export$2e2bcd8739ae039(all) {
    all = all || new Map();
    // Throttling state
    const throttleTimers = new Map();
    const eventQueue = new Map();
    return {
        all: /**
     * A Map of event names to registered handler functions.
     */ all,
        /**
     * Register an event handler for the given type.
     * @param {string|symbol} type Type of event to listen for, or `'*'` for all events
     * @param {Function} handler Function to call in response to given event
     * @memberOf mitt
     */ on (type, handler) {
            const handlers = all.get(type);
            if (handlers) handlers.push(handler);
            else all.set(type, [
                handler
            ]);
        },
        /**
     * Remove an event handler for the given type.
     * If `handler` is omitted, all handlers of the given type are removed.
     * @param {string|symbol} type Type of event to unregister `handler` from (`'*'` to remove a wildcard handler)
     * @param {Function} [handler] Handler function to remove
     * @memberOf mitt
     */ off (type, handler) {
            const handlers = all.get(type);
            if (handlers) {
                if (handler) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
                else all.set(type, []);
            }
        },
        /**
     * Invoke all handlers for the given type.
     * If present, `'*'` handlers are invoked after type-matched handlers.
     *
     * Note: Manually firing '*' handlers is not supported.
     *
     * @param {string|symbol} type The event type to invoke
     * @param {Any} [evt] Any value (object is recommended and powerful), passed to each handler
     * @memberOf mitt
     */ emit (type, evt) {
            // Queue the event
            if (!eventQueue.has(type)) eventQueue.set(type, []);
            eventQueue.get(type).push(evt);
            // If a throttle timer exists, do nothing
            if (throttleTimers.has(type)) return;
            // Set up a throttle timer
            throttleTimers.set(type, setTimeout(()=>{
                const time = `${new Date().getMinutes()}:${new Date().getSeconds()}`;
                console.log(`[EVENT]: ${String(type)} ${time}`);
                // Get all queued events
                const queuedEvents = eventQueue.get(type) || [];
                eventQueue.delete(type);
                // Execute all handlers for the type
                let handlers = all.get(type);
                if (handlers) queuedEvents.forEach((event)=>{
                    handlers.slice().forEach((handler)=>{
                        handler(event);
                    });
                });
                // Execute wildcard handlers
                handlers = all.get("*");
                if (handlers) queuedEvents.forEach((event)=>{
                    handlers.slice().forEach((handler)=>{
                        handler(type, event);
                    });
                });
                // Clear the throttle timer
                throttleTimers.delete(type);
            }, 50));
        }
    };
}


const $eeb13d182ec6db0f$var$eventBus = (0, $6b4070ff9ee527a8$export$2e2bcd8739ae039)();
var $eeb13d182ec6db0f$export$2e2bcd8739ae039 = $eeb13d182ec6db0f$var$eventBus;



const $10b89994322a4ed4$export$a5623602025e5f71 = "is-active";
const $10b89994322a4ed4$export$87fb08158daf13c5 = "is-ready";
var $10b89994322a4ed4$export$290d4780f94d8760;
(function(NavigatorEventBus) {
    NavigatorEventBus["navigationEnd"] = "navigationEnd";
    NavigatorEventBus["navigationStart"] = "navigationStart";
    NavigatorEventBus["mapChanged"] = "mapChanged";
})($10b89994322a4ed4$export$290d4780f94d8760 || ($10b89994322a4ed4$export$290d4780f94d8760 = {}));
const $10b89994322a4ed4$export$d7dec8208a163e28 = 1000;


const $dd0a3fcf504f9f39$export$c46d6023a5b25b92 = "autosave";


class $4f0cb90897ee070c$export$61e9caf654e23bd2 {
    constructor(){
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationEnd, (poi)=>this.autosave(poi));
    }
    static getInstance() {
        if (!$4f0cb90897ee070c$export$61e9caf654e23bd2.instance) $4f0cb90897ee070c$export$61e9caf654e23bd2.instance = new $4f0cb90897ee070c$export$61e9caf654e23bd2();
        return $4f0cb90897ee070c$export$61e9caf654e23bd2.instance;
    }
    autosave(poi) {
        this.save({
            poi: poi
        });
    }
    get autosaveValue() {
        const autosaveValue = localStorage.getItem((0, $dd0a3fcf504f9f39$export$c46d6023a5b25b92));
        if (!autosaveValue) return null;
        const parsedAutosaveValue = JSON.parse(autosaveValue);
        if (this.isAutosaveValue(parsedAutosaveValue)) return parsedAutosaveValue;
        return null;
    }
    save(partial) {
        const merged = {
            ...this.autosaveValue ?? {},
            ...partial
        };
        if (!merged.poi) return; // never persist without a POI anchor
        localStorage.setItem((0, $dd0a3fcf504f9f39$export$c46d6023a5b25b92), JSON.stringify(merged));
    }
    get currentPOI() {
        return this.autosaveValue?.poi || null;
    }
    isAutosaveValue(value) {
        return value.poi !== undefined;
    }
}


const $c525691551415870$export$833555f9c450dec5 = "start";
var $c525691551415870$export$290cb7291ee58b61;
(function(DialogType) {
    DialogType["dialog"] = "dialog";
    DialogType["description"] = "description";
})($c525691551415870$export$290cb7291ee58b61 || ($c525691551415870$export$290cb7291ee58b61 = {}));
var $c525691551415870$export$99f1f21fef99148b;
(function(NarratorEventBus) {
    NarratorEventBus["narratorStart"] = "narratorStart";
    NarratorEventBus["dialogStart"] = "dialogStart";
    NarratorEventBus["nodeEntered"] = "nodeEntered";
})($c525691551415870$export$99f1f21fef99148b || ($c525691551415870$export$99f1f21fef99148b = {}));


const $91e226332d78d6cc$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "A low bathhouse sits back from the road, steam curling out under the door. A bathmaid leans in the doorway. She watches the road, then watches you, and smiles.",
        options: [
            {
                text: "Step inside.",
                nextDialogId: "welcome"
            },
            {
                text: "Linger in the doorway.",
                nextDialogId: "caught"
            }
        ]
    },
    {
        id: "welcome",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Well now. The road has been hard on you, love. Come in out of the cold. I can make a new man of you.",
        options: [
            {
                text: "What do you offer?",
                nextDialogId: "services"
            },
            {
                text: "Just looking, for now.",
                nextDialogId: "caught"
            }
        ]
    },
    {
        id: "caught",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "See something you like, traveller? The water is warmer than the doorway, I promise you that.",
        options: [
            {
                text: "Ask what she offers.",
                nextDialogId: "services"
            },
            {
                text: "Step inside, smiling.",
                nextDialogId: "welcome"
            }
        ]
    },
    {
        id: "services",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A hot bath, for a start. Or I can see to your cuts, or wash the road off your clothes. What will it be, love?",
        options: [
            {
                text: "A hot bath.",
                nextDialogId: "bath"
            },
            {
                text: "Your other comforts?",
                nextDialogId: "comforts"
            }
        ]
    },
    {
        id: "comforts",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Your cuts, or your clothes. I have gentle hands for both, if you are brave enough.",
        options: [
            {
                text: "Tend my cuts.",
                nextDialogId: "wounds"
            },
            {
                text: "Wash my clothes.",
                nextDialogId: "laundry"
            }
        ]
    },
    {
        id: "bath",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "She leads you to a steaming tub and tests the water with one hand. You climb in, and the heat soaks the road out of your bones. She stays close by, humming, never quite out of sight.",
        options: [
            {
                text: "Let the warmth take you.",
                nextDialogId: "done"
            }
        ]
    },
    {
        id: "wounds",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Sit, love, and let me see. This will sting. But you look like a man who can take a little pain.",
        options: [
            {
                text: "Gentle indeed.",
                nextDialogId: "done"
            }
        ]
    },
    {
        id: "laundry",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Out of those, then, and I will have the mud off them by morning. Do not be shy. I have seen worse than you, love.",
        options: [
            {
                text: "I will wait.",
                nextDialogId: "done"
            }
        ]
    },
    {
        id: "done",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "There. Good as new, near enough. Come back when the road wears you down again. It always does.",
        options: [
            {
                text: "Maybe another time.",
                nextDialogId: "start"
            },
            {
                text: "Actually, something else.",
                nextDialogId: "services"
            }
        ]
    }
];


const $7e1823c22ea3e407$export$de30803e26991d1c = {
    id: "bathmaid",
    name: "Bathmaid",
    dialog: (0, $91e226332d78d6cc$export$518824cf31321346)
};





const $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f = {
    worm: {
        id: "worm",
        name: "Handful of worms",
        weight: 0.1,
        maxStack: 1,
        sellable: false,
        description: "A handful of fat worms, dug from the wet earth under the oak. Enough bait for a day by the water."
    },
    rod: {
        id: "rod",
        name: "Fishing rod",
        weight: 0,
        sellable: false,
        description: "An old rod of hazel and waxed line. It has seen many winters by the water."
    },
    trout: {
        id: "trout",
        name: "Trout",
        weight: 2,
        sellable: true,
        price: 3,
        description: "A silver trout from the fast water. Firm flesh, and welcome on a fast day."
    },
    chub: {
        id: "chub",
        name: "Chub",
        weight: 2,
        sellable: true,
        price: 2,
        description: "A fat chub from the slow water. Full of bones, but it fills a pot."
    },
    pike: {
        id: "pike",
        name: "Pike",
        weight: 4,
        sellable: true,
        price: 8,
        description: "A long pike, all teeth and muscle. The lords pay well for one this size."
    },
    eel: {
        id: "eel",
        name: "Eel",
        weight: 2,
        sellable: true,
        price: 5,
        description: "A dark eel, taken toward evening. Hard to hold, fine to eat."
    },
    coins: {
        id: "coins",
        name: "Coins",
        weight: 0,
        sellable: false,
        hideInInventory: true,
        description: "Deniers, the small coin of these parts. Twelve make a sou, and twenty sous a livre."
    },
    backpack: {
        id: "backpack",
        name: "Backpack",
        weight: 0,
        sellable: false,
        capacityBonus: 20,
        hideInInventory: true,
        description: "A stout pack of good leather. What will not fit in your hands rides on your back."
    },
    charm: {
        id: "charm",
        name: "Protective charm",
        weight: 0,
        sellable: false,
        description: "A small charm, blessed by the priest at the chapel. He swears it keeps the road's dangers from you."
    }
};


const $c154c7fb9f805405$export$b7ff8ddbad63f099 = 10;
const $c154c7fb9f805405$var$ids = (state)=>Object.keys(state.items);
const $c154c7fb9f805405$export$de32fe5d64aee40c = (state)=>$c154c7fb9f805405$var$ids(state).reduce((sum, id)=>sum + ((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id]?.weight ?? 0) * (state.items[id] ?? 0), 0);
const $c154c7fb9f805405$export$c5efcc30107f1083 = (weight)=>String(Math.round(weight * 10) / 10);
const $c154c7fb9f805405$export$de7d27adbe6f40ec = (state)=>$c154c7fb9f805405$var$ids(state).reduce((sum, id)=>sum + ((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id]?.capacityBonus ?? 0) * (state.items[id] ?? 0), 0);
const $c154c7fb9f805405$export$55b283886ec2d3fb = (state)=>$c154c7fb9f805405$export$b7ff8ddbad63f099 + $c154c7fb9f805405$export$de7d27adbe6f40ec(state);
const $c154c7fb9f805405$export$2f400479c9c17eaa = (state, id, quantity = 1)=>{
    const item = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id];
    // Hard per-item stack cap (e.g. bait), independent of weight.
    if (item?.maxStack !== undefined && (state.items[id] ?? 0) + quantity > item.maxStack) return false;
    const added = (item?.weight ?? 0) * quantity;
    if (added <= 0) return true;
    return $c154c7fb9f805405$export$de32fe5d64aee40c(state) + added <= $c154c7fb9f805405$export$55b283886ec2d3fb(state);
};


const $92fa1d405ed90899$var$handlers = {
    grant: (state, effect)=>{
        if (effect.type !== "grant") return state;
        // All-or-nothing: if the whole grant would push past carry capacity, refuse
        // it entirely (you cannot pick up what you cannot carry).
        if (!(0, $c154c7fb9f805405$export$2f400479c9c17eaa)(state, effect.item, effect.quantity)) return state;
        const current = state.items[effect.item] ?? 0;
        return {
            items: {
                ...state.items,
                [effect.item]: current + effect.quantity
            }
        };
    },
    consume: (state, effect)=>{
        if (effect.type !== "consume") return state;
        const current = state.items[effect.item] ?? 0;
        const next = Math.max(current - effect.quantity, 0);
        if (next === current) return state;
        return {
            items: {
                ...state.items,
                [effect.item]: next
            }
        };
    }
};
const $92fa1d405ed90899$export$59a7b217c53300d2 = (state, effect)=>$92fa1d405ed90899$var$handlers[effect.type](state, effect);
const $92fa1d405ed90899$export$d4dfae56ea8bda62 = (state, id)=>state.items[id] ?? 0;


var $f5ff537df8440e15$export$af1a6ad62b6fae06;
(function(InventoryEventBus) {
    InventoryEventBus["changed"] = "inventoryChanged";
})($f5ff537df8440e15$export$af1a6ad62b6fae06 || ($f5ff537df8440e15$export$af1a6ad62b6fae06 = {}));


class $73473c2d2f75563d$export$a033e390692f359f {
    constructor(repository){
        this.repository = repository;
        this.state = repository.load();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $c525691551415870$export$99f1f21fef99148b).nodeEntered, (payload)=>this.onNodeEntered(payload.effects));
    }
    static init(repository) {
        if (!$73473c2d2f75563d$export$a033e390692f359f.instance) $73473c2d2f75563d$export$a033e390692f359f.instance = new $73473c2d2f75563d$export$a033e390692f359f(repository);
        return $73473c2d2f75563d$export$a033e390692f359f.instance;
    }
    static getInstance() {
        if (!$73473c2d2f75563d$export$a033e390692f359f.instance) throw new Error("Inventory.init(repository) must be called before getInstance().");
        return $73473c2d2f75563d$export$a033e390692f359f.instance;
    }
    getState() {
        return this.state;
    }
    onNodeEntered(effects) {
        let next = this.state;
        for (const effect of effects)next = (0, $92fa1d405ed90899$export$59a7b217c53300d2)(next, effect);
        if (next === this.state) return;
        this.state = next;
        this.repository.save(this.state);
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $f5ff537df8440e15$export$af1a6ad62b6fae06).changed);
    }
}



const $2d3c1f85632ea698$var$state = ()=>(0, $73473c2d2f75563d$export$a033e390692f359f).getInstance().getState();
const $2d3c1f85632ea698$export$77d5aafae4e095b2 = (id)=>$2d3c1f85632ea698$var$state().items[id] ?? 0;
const $2d3c1f85632ea698$export$5d8958bbf054854f = (id)=>$2d3c1f85632ea698$export$77d5aafae4e095b2(id) > 0;
const $2d3c1f85632ea698$export$48a8e0809c5223e6 = (id)=>(0, $c154c7fb9f805405$export$2f400479c9c17eaa)($2d3c1f85632ea698$var$state(), id);
const $2d3c1f85632ea698$export$c6ac54da451c713d = ()=>(0, $c154c7fb9f805405$export$de32fe5d64aee40c)($2d3c1f85632ea698$var$state());
const $2d3c1f85632ea698$export$42af0798b3617008 = ()=>(0, $c154c7fb9f805405$export$55b283886ec2d3fb)($2d3c1f85632ea698$var$state());


function $df9f945c974db323$export$417b56c3f573f569(entries) {
    if (entries.length === 0) throw new Error("weightedPick: entries must not be empty");
    const total = entries.reduce((sum, [, weight])=>sum + weight, 0);
    let roll = Math.random() * total;
    for (const [value, weight] of entries){
        roll -= weight;
        if (roll < 0) return value;
    }
    return entries[entries.length - 1][0];
}


// Fishing is a *session*, not a cast. Starting one needs a handful of worms,
// spent up front as the bait for the whole outing. You play through a single
// bite with one choice, then the rest of the day is narrated and you take home a
// haul that depends on the choice you made.
// Pull it in now = the safe play: a modest, sure haul (small chance of a joke).
function $327a53ec5dd4d498$var$resolvePullNow() {
    return (0, $df9f945c974db323$export$417b56c3f573f569)([
        [
            "haul_safe_a",
            45
        ],
        [
            "haul_safe_b",
            45
        ],
        [
            "bust_boot",
            10
        ]
    ]);
}
// Let it run = the gamble: a bigger haul, the one that got away, or a joke.
function $327a53ec5dd4d498$var$resolveLetRun() {
    return (0, $df9f945c974db323$export$417b56c3f573f569)([
        [
            "haul_big_pike",
            30
        ],
        [
            "haul_big_eel",
            30
        ],
        [
            "got_away",
            25
        ],
        [
            "bust_boot",
            8
        ],
        [
            "bust_eeltrap",
            7
        ]
    ]);
}
const $327a53ec5dd4d498$var$AWAY = {
    text: "Step back from the water.",
    nextDialogId: "start"
};
const $327a53ec5dd4d498$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The fisherman stands in the shallow water of the Alzette. He watches his line. He turns when he hears you and gives a small nod.",
        options: [
            {
                text: "Ask what fish he catches here.",
                nextDialogId: "fish_list"
            },
            {
                text: "Stand and watch for a moment.",
                nextDialogId: "watching",
                condition: ()=>!(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod")
            },
            {
                text: "Where can I find worms?",
                nextDialogId: "worms",
                condition: ()=>(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod") && !(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("worm")
            },
            {
                text: "Fish here.",
                nextDialogId: "session_bite",
                condition: ()=>(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod") && (0, $2d3c1f85632ea698$export$5d8958bbf054854f)("worm")
            }
        ]
    },
    {
        id: "fish_list",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Trout, where the water runs fast. Chub, where it is slow. A pike if you are lucky. Eels toward evening. The rest is between you and the river, as the Alzette runs.",
        options: [
            {
                text: "Could I try fishing too?",
                nextDialogId: "offer",
                condition: ()=>!(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod")
            },
            {
                text: "Goodbye and good fishing.",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "watching",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "He lets you stand a while. The line moves slowly in the water. After a long pause he looks up, then waves you over with his hand.",
        options: [
            {
                text: "(Step closer.)",
                nextDialogId: "offer",
                condition: ()=>!(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod")
            },
            {
                text: "(Walk away.)",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "offer",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "You have the look of a man with nothing to do. I have a spare rod here. It is old, but it still works. Take it. You will need worms first, though. The fish do not catch themselves.",
        options: [
            {
                text: "Take the rod and thank him.",
                nextDialogId: "accept"
            },
            {
                text: "Where should I dig for worms?",
                nextDialogId: "worms"
            }
        ]
    },
    {
        id: "worms",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Go east from here. Past the crossroad you will find a big **oak tree**. The earth under its roots is dark and wet, full of fat worms. A handful of them is better than any other bait.",
        options: [
            {
                text: "I'll go and dig.",
                nextDialogId: "accept",
                condition: ()=>!(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod")
            },
            {
                text: "Thank you.",
                nextDialogId: "start",
                condition: ()=>(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("rod")
            }
        ]
    },
    {
        id: "accept",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Here. Hold it carefully. It has been with me all winter. Good fishing, friend. As the Alzette runs.",
        effects: [
            {
                type: "grant",
                item: "rod",
                quantity: 1
            }
        ],
        options: [
            {
                text: "Walk away.",
                nextDialogId: "start"
            }
        ]
    },
    // --- The session: bite -> one choice -> a narrated haul ----------------------
    {
        id: "session_bite",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        // The handful is spent here, at the start: it is the bait for the whole session.
        text: "You bait the hook and throw the line into the water. For a long while it lies still. Then it pulls tight, and something strong fights on the other end.",
        effects: [
            {
                type: "consume",
                item: "worm",
                quantity: 1
            }
        ],
        options: [
            {
                text: "Pull it in now.",
                nextDialogId: $327a53ec5dd4d498$var$resolvePullNow
            },
            {
                text: "Let it run a little.",
                nextDialogId: $327a53ec5dd4d498$var$resolveLetRun
            }
        ]
    },
    // Safe play: a modest, sure haul. (Best fish granted first, so a full pack keeps the best.)
    {
        id: "haul_safe_a",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You pull it in steady and lift out a fat **chub**. You stay by the water into the afternoon and take a **trout** more before the light goes. A fair day.",
        effects: [
            {
                type: "grant",
                item: "trout",
                quantity: 1
            },
            {
                type: "grant",
                item: "chub",
                quantity: 1
            }
        ],
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    {
        id: "haul_safe_b",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You bring it up clean, a fat **chub**. The slow water gives one more **chub** before you leave. Plain fish, but they fill a pot.",
        effects: [
            {
                type: "grant",
                item: "chub",
                quantity: 1
            },
            {
                type: "grant",
                item: "chub",
                quantity: 1
            }
        ],
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    // The gamble pays off.
    {
        id: "haul_big_pike",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You give it line, and it fights hard across the water. When it tires, you drag up a long **pike**. After that the fish come easy, and a **trout** and a **chub** join it in your bag.",
        effects: [
            {
                type: "grant",
                item: "pike",
                quantity: 1
            },
            {
                type: "grant",
                item: "trout",
                quantity: 1
            },
            {
                type: "grant",
                item: "chub",
                quantity: 1
            }
        ],
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    {
        id: "haul_big_eel",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You let it wind deep, then bring it up slow: a dark **eel**, thick as your wrist. The evening turns kind, and two **trout** follow it in before the light fails.",
        effects: [
            {
                type: "grant",
                item: "eel",
                quantity: 1
            },
            {
                type: "grant",
                item: "trout",
                quantity: 1
            },
            {
                type: "grant",
                item: "trout",
                quantity: 1
            }
        ],
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    // The gamble fails: the one that got away.
    {
        id: "got_away",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You let it run too long. One hard pull and the line goes slack, worm and all. Whatever it was, it beat you, and the fish keep their distance after that. You take home one small **chub** and little else.",
        effects: [
            {
                type: "grant",
                item: "chub",
                quantity: 1
            }
        ],
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    // Busts: funny, world-building, no fish. The bait is already spent.
    {
        id: "bust_boot",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You pull, sure of a fish. It is an old **boot**, heavy with river water. Nothing better comes all day. The river keeps its own jokes.",
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    },
    {
        id: "bust_eeltrap",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You heave up not a fish but a rotted **eel-trap**, half its sticks gone. Someone down in **Dommeldange** is a trap short, and none too pleased. You catch nothing after.",
        options: [
            $327a53ec5dd4d498$var$AWAY
        ]
    }
];


const $e0de2594b7852815$export$a7b603ca93c48062 = {
    id: "fisherman-beggen",
    name: "Fisherman",
    dialog: (0, $327a53ec5dd4d498$export$518824cf31321346)
};



const $c20f33a174229abd$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The hunter stands by the lodge, a bow across his back. He watches the treeline, then gives you a short nod.",
        options: [
            {
                text: "Greet him.",
                nextDialogId: "greet"
            },
            {
                text: "Watch the woods with him.",
                nextDialogId: "watch"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Game, or rest? The woods keep me. I keep to the woods.",
        options: [
            {
                text: "What do you hunt?",
                nextDialogId: "game"
            },
            {
                text: "You live out here alone?",
                nextDialogId: "alone"
            }
        ]
    },
    {
        id: "game",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Deer, boar, hare. Whatever the season gives. The bow does not ask questions.",
        options: [
            {
                text: "Any luck lately?",
                nextDialogId: "luck"
            },
            {
                text: "Good hunting, then.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "luck",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A boar, two days back. He led me half a morning before he tired. A fair fight.",
        options: [
            {
                text: "Well earned.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "alone",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Alone suits me. Men are louder than boar, and harder to read.",
        options: [
            {
                text: "Fair enough.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "watch",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "He does not speak. His eyes move along the trees, reading what you cannot. After a while he points at a broken branch, then lets his hand fall.",
        options: [
            {
                text: "Ask what he sees.",
                nextDialogId: "game"
            },
            {
                text: "Leave him to it.",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "bye",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Keep to the path, traveller. The woods are no place to wander.",
        options: [
            {
                text: "I will.",
                nextDialogId: "start"
            }
        ]
    }
];


const $e5c53dc42568747e$export$1c0eb4afad0324c7 = {
    id: "hunter",
    name: "Hunter",
    dialog: (0, $c20f33a174229abd$export$518824cf31321346)
};



const $00a76dabe0fd0ad9$export$518824cf31321346 = [
    {
        id: "start",
        text: "The building looks inviting, a place to rest from the road. A sign sways gently in the breeze, its creak adding to the cozy charm of the place.",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        options: [
            {
                text: "Enter",
                nextDialogId: "tavern"
            }
        ]
    },
    {
        id: "tavern",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You step inside, the warmth of the tavern enveloping you like a welcoming embrace. The scent of hearty food and spiced ale fills the air. At the bar, a young, pretty waitress catches your eye. She\u2019s laughing lightly with a merchant, her eyes sparkling with a playful energy. Her smile seems to linger a little longer than necessary as she notices your gaze.",
        options: [
            {
                text: "Listen in on their conversation.",
                nextDialogId: "welcome"
            },
            {
                text: "Catch the waitress\u2019s attention.",
                nextDialogId: "waitress_attention"
            }
        ]
    },
    {
        id: "welcome",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: 'The waitress leans closer to the merchant with a grin. "Two coins for a tallow candle? You would charge a drowning man for the rope, good merchant." The merchant only smiles into his cup. She is plainly enjoying herself.',
        options: [
            {
                text: "Continue listening",
                nextDialogId: "merchant_response"
            },
            {
                text: "Get the attention of the waitress.",
                nextDialogId: "waitress_attention"
            }
        ]
    },
    {
        id: "merchant_response",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: 'The merchant spreads his hands. "A man must live, girl. The roads are long, and the tolls on them longer still." He drains his cup and rises. The waitress tilts her head, then her gaze drifts toward you, lingering just a moment too long.',
        name: "Merchant",
        options: [
            {
                text: "Continue listening",
                nextDialogId: "innkeeper_advice"
            },
            {
                text: "Get the attention of the waitress.",
                nextDialogId: "waitress_attention"
            }
        ]
    },
    {
        id: "waitress_attention",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The waitress notices you looking her way, a coy smile curling on her lips. She wipes a glass clean and saunters over with a playful twinkle in her eyes. 'Well, hello there, stranger. What brings you to my little corner of the world?' she asks, her tone teasing.",
        options: [
            {
                text: "Ask for a drink.",
                nextDialogId: "drink_order"
            },
            {
                text: "Compliment her smile.",
                nextDialogId: "flirty_exchange"
            },
            {
                text: "Ask for a room",
                nextDialogId: "stay_for_night"
            },
            {
                text: "Flee",
                nextDialogId: "flee"
            }
        ]
    },
    {
        id: "flee",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "You do not know how to react. You quickly grab your stuff",
        options: [
            {
                text: "Leave the tavern",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "flirty_exchange",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: 'Her smile widens as she hears your compliment. "Flattery will get you everywhere, traveler," she says, her voice low and playful. "But I warn you, I\u2019m not so easily won over." She gives you a wink before turning to fetch your drink.',
        options: [
            {
                text: "Continue the conversation.",
                nextDialogId: "waitress_attention"
            },
            {
                text: "Sit back and enjoy the atmosphere.",
                nextDialogId: "end_dialog"
            }
        ]
    },
    {
        id: "drink_order",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: 'You order a drink, and she nods with a playful grin. "Coming right up. But don\u2019t get too comfortable, I might just have other ways to keep you entertained," she teases before walking away.',
        options: [
            {
                text: "Wait for your drink and enjoy the ambiance.",
                nextDialogId: "end_dialog"
            },
            {
                text: "Ask for a room",
                nextDialogId: "stay_for_night"
            },
            {
                text: "Look around the tavern for something else to do.",
                nextDialogId: "end_dialog"
            }
        ]
    },
    {
        id: "innkeeper_advice",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Listen more than you speak, traveller. The folk on the road carry news worth more than coin in days like these.",
        options: [
            {
                text: "Thank you for the advice!",
                nextDialogId: "end_dialog"
            }
        ]
    },
    {
        id: "stay_for_night",
        text: "You lean in slightly, your voice casual but with a hint of interest. 'I\u2019d like a room for the night.' The waitress's eyes sparkle as she flashes you a playful smile. 'Of course, traveler. You\u2019ve made a wise choice. A warm bed, a hearty meal, and maybe a bit more, if you're lucky.' She gives you a lingering glance before adding, 'Make yourself at home, and I\u2019ll see to your needs.' With that, you settle in, the comfort of the tavern surrounding you as you wonder what surprises tomorrow might bring.",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        options: [
            {
                text: "Sleep",
                nextDialogId: "morning_wakeup"
            }
        ]
    },
    {
        id: "morning_wakeup",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The morning sun filters through the tavern's windows, casting warm, golden light across the room. You wake up feeling rested, the soft sound of birds chirping outside reminding you that a new day has begun. The tavern is quiet, save for the occasional clink of a mug from downstairs. You stretch and take a deep breath, the air fresh and filled with promise. The bed was comfortable, but the day ahead calls to you. You wonder what adventures await.",
        options: [
            {
                text: "Get up and step out into the day.",
                nextDialogId: "step_outside"
            },
            {
                text: "Take a moment to enjoy the peaceful atmosphere.",
                nextDialogId: "stay_for_now"
            }
        ]
    },
    {
        id: "step_outside",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "You rise from the bed, stretch one last time, and make your way downstairs. The waitress looks up from behind the bar with a smile, her eyes twinkling as she watches you approach. 'Good morning, traveler,' she says with a teasing tone. 'I see you\u2019re up early, ready to conquer the day?' As you step outside into the crisp morning air, you feel her gaze lingering on you for just a moment longer.",
        options: [
            {
                text: "Step outside",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "stay_for_now",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "You take a few moments to savor the peaceful morning. The warmth of the tavern contrasts with the cool morning air outside. As you relax, you hear the soft click of footsteps approaching, and the waitress appears beside you with a playful grin. 'I thought you might need some company before you head out,' she says, her voice light and teasing. 'You\u2019re not in a rush, are you?' You smile and sip your drink, enjoying the moment.",
        options: [
            {
                text: "Now, it\u2019s time to step outside and begin your day.",
                nextDialogId: "step_outside"
            }
        ]
    },
    {
        id: "end_dialog",
        text: "The conversation fades, and you consider your next move.",
        options: [
            {
                text: "Get the attention of the waitress.",
                nextDialogId: "waitress_attention"
            }
        ],
        type: (0, $c525691551415870$export$290cb7291ee58b61).description
    }
];


const $17c98f18e7ce3a62$export$6424da03e6f0f8bf = {
    id: "innkeeper",
    name: "Waitress",
    dialog: (0, $00a76dabe0fd0ad9$export$518824cf31321346)
};



const $7f194d1ae58c8081$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "Lord Henri of Bourscheid stands before his keep, a steward at his shoulder. He looks you over without warmth.",
        options: [
            {
                text: "Bow and greet him.",
                nextDialogId: "greet"
            },
            {
                text: "Wait to be addressed.",
                nextDialogId: "wait"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A traveller. State your business, or be brief. A lord has cares enough without strangers at his gate.",
        options: [
            {
                text: "What cares, my lord?",
                nextDialogId: "cares"
            },
            {
                text: "I am only passing through.",
                nextDialogId: "pass"
            }
        ]
    },
    {
        id: "cares",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The land all but governs itself these days. Our count is forever elsewhere.",
        options: [
            {
                text: "Where is the count?",
                nextDialogId: "count"
            },
            {
                text: "I will not keep you, my lord.",
                nextDialogId: "pass"
            }
        ]
    },
    {
        id: "count",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Charles wears the Roman crown and holds court in Prague. Luxembourg is a small jewel in a large hand now.",
        options: [
            {
                text: "Who will hold it, then?",
                nextDialogId: "heir"
            },
            {
                text: "I understand, my lord.",
                nextDialogId: "pass"
            }
        ]
    },
    {
        id: "heir",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "His young half-brother, Wenceslaus, when the boy is grown. Until then, men like me hold the land and answer for it.",
        options: [
            {
                text: "Thank you for your time, my lord.",
                nextDialogId: "pass"
            }
        ]
    },
    {
        id: "wait",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You hold your tongue. He tires of the silence soon enough and speaks first.",
        options: [
            {
                text: "(Listen.)",
                nextDialogId: "greet"
            }
        ]
    },
    {
        id: "pass",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Then go, and keep to the road. May your journey be safe.",
        options: [
            {
                text: "Leave.",
                nextDialogId: "start"
            }
        ]
    }
];


const $256c1187d600ce70$export$5ef0a1510acd70b2 = {
    id: "lord-bourscheid",
    name: "Lord Henri of Bourscheid",
    dialog: (0, $7f194d1ae58c8081$export$518824cf31321346)
};





const $ed998af689594359$var$BACKPACK_PRICE = 24; // 2 sous
const $ed998af689594359$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The merchant sits at a table outside a low house. Cloth, iron nails, and dried herbs lie under his hand. He weighs a coin in his palm and watches you come.",
        options: [
            {
                text: "Sell or buy wares.",
                nextDialogId: "wares"
            },
            {
                text: "Talk with him.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "wares",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        openMerchant: true,
        text: "Lay your goods on the table, friend. I pay fair coin for fish. Coin is honest. The rest is talk.",
        options: [
            {
                text: "Step back from the table.",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "talk",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Cloth, nails, dried herbs for a sick belly. A little of this, a little of that. I go where the roads take me.",
        options: [
            {
                text: "Anything to help me carry more?",
                nextDialogId: ()=>{
                    if ((0, $2d3c1f85632ea698$export$5d8958bbf054854f)("backpack")) return (0, $2d3c1f85632ea698$export$c6ac54da451c713d)() <= (0, $c154c7fb9f805405$export$b7ff8ddbad63f099) ? "pack_sell" : "pack_too_full";
                    return (0, $2d3c1f85632ea698$export$77d5aafae4e095b2)("coins") >= $ed998af689594359$var$BACKPACK_PRICE ? "pack_offer" : "pack_poor";
                }
            },
            {
                text: "Heard any news on the road?",
                nextDialogId: "news"
            }
        ]
    },
    {
        id: "pack_offer",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A stout backpack, good leather. Two sous, and you will carry far more than your two arms allow.",
        options: [
            {
                text: "Buy it.",
                nextDialogId: "pack_bought"
            },
            {
                text: "Maybe later.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "pack_bought",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Wear it well. Your shoulders will complain, but your purse will thank you for what it carries.",
        effects: [
            {
                type: "consume",
                item: "coins",
                quantity: $ed998af689594359$var$BACKPACK_PRICE
            },
            {
                type: "grant",
                item: "backpack",
                quantity: 1
            }
        ],
        options: [
            {
                text: "My thanks.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "pack_poor",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A stout backpack, two sous. Come back when your purse is heavier, friend.",
        options: [
            {
                text: "I will.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "pack_sell",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Done with the backpack? I will take it back for the two sous you paid. A fair trade.",
        options: [
            {
                text: "Sell it back.",
                nextDialogId: "pack_sold"
            },
            {
                text: "Keep it.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "pack_sold",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "There. Lighter on your back, heavier in your purse. Come find me when the roads ask more of you.",
        effects: [
            {
                type: "consume",
                item: "backpack",
                quantity: 1
            },
            {
                type: "grant",
                item: "coins",
                quantity: $ed998af689594359$var$BACKPACK_PRICE
            }
        ],
        options: [
            {
                text: "My thanks.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "pack_too_full",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Sell it back? Empty it first, friend. You cannot carry that load on your two arms alone.",
        options: [
            {
                text: "Right.",
                nextDialogId: "talk"
            }
        ]
    },
    {
        id: "news",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Fewer people on the roads this year. There is sickness in the south, they say. I do not go that way now.",
        options: [
            {
                text: "Is it coming here?",
                nextDialogId: "news_more"
            },
            {
                text: "Let me trade, then.",
                nextDialogId: "wares"
            }
        ]
    },
    {
        id: "news_more",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Not here, not yet. The county watches its bridges and turns the sick away. I keep to the north roads and sleep with one eye open.",
        options: [
            {
                text: "Wise. Let me trade.",
                nextDialogId: "wares"
            },
            {
                text: "Safe travels.",
                nextDialogId: "start"
            }
        ]
    }
];


const $05ecb4dd8c145330$export$a263b10ef1321bba = {
    id: "merchant-beggen",
    name: "Merchant",
    dialog: (0, $ed998af689594359$export$518824cf31321346)
};



const $395a0b0575e99c72$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The miller looks up from the turning stone, flour white on his arms.",
        options: [
            {
                text: "Greet him.",
                nextDialogId: "greet"
            },
            {
                text: "Ask about his mill.",
                nextDialogId: "mill"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Good day to you. Flour, or just passing? The wheel turns either way.",
        options: [
            {
                text: "Tell me of the mill.",
                nextDialogId: "mill"
            },
            {
                text: "Just passing.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "mill",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "My father turned this wheel, and his before him. Good stone, good water from the Alzette. It never fails me.",
        options: [
            {
                text: "Is the work hard?",
                nextDialogId: "work"
            },
            {
                text: "Fine work.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "work",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Hard enough. The stone must be dressed, the water watched, the grain kept dry. But bread does not make itself.",
        options: [
            {
                text: "True enough.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "bye",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Take care, traveller. Mind the mud on the path.",
        options: [
            {
                text: "Leave.",
                nextDialogId: "start"
            }
        ]
    }
];


const $792a456285edc44f$export$1a534d91e74f2da2 = {
    id: "miller",
    name: "Miller",
    dialog: (0, $395a0b0575e99c72$export$518824cf31321346)
};



const $75a4bd32d423e835$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "Niklas stands in the doorway of a low house, wiping his hands on a cloth. He nods as you come near.",
        options: [
            {
                text: "Greet him.",
                nextDialogId: "greet"
            },
            {
                text: "Ask how he fares.",
                nextDialogId: "fare"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Good day, traveller. Not many faces pass this way now.",
        options: [
            {
                text: "Why so few?",
                nextDialogId: "plague"
            },
            {
                text: "Just passing through.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "fare",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Well enough. Better than some. The house beside mine has stood shut since autumn.",
        options: [
            {
                text: "Shut? Why?",
                nextDialogId: "plague"
            },
            {
                text: "I am glad you are well.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "plague",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The sickness came through the village. It took my brother and his wife both. We do not speak of it much.",
        options: [
            {
                text: "I am sorry.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "bye",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Safe travels, friend. Mind the road.",
        options: [
            {
                text: "Leave.",
                nextDialogId: "start"
            }
        ]
    }
];


const $556f2ce50c13c8e1$export$6cb3f86b688595e = {
    id: "niklas",
    name: "Niklas",
    dialog: (0, $75a4bd32d423e835$export$518824cf31321346)
};





// One tap -> a weighted outcome. ~70% a handful of worms (three flavour variants),
// ~30% a find *instead*. A find is a line to read, not loot: only the coin is
// kept, the rest are pure flavour, so nothing clutters the pack. Same pattern as
// the fishing session.
function $6e3c84ae2ea1dd92$var$resolveDig() {
    return (0, $df9f945c974db323$export$417b56c3f573f569)([
        [
            "worms_a",
            24
        ],
        [
            "worms_b",
            23
        ],
        [
            "worms_c",
            23
        ],
        [
            "find_coin",
            10
        ],
        [
            "find_boot",
            4
        ],
        [
            "find_key",
            4
        ],
        [
            "find_tooth",
            4
        ],
        [
            "find_squirrel",
            4
        ],
        [
            "find_whistle",
            4
        ]
    ]);
}
const $6e3c84ae2ea1dd92$var$DIG = {
    text: "Dig in the earth for worms.",
    nextDialogId: $6e3c84ae2ea1dd92$var$resolveDig,
    condition: ()=>(0, $2d3c1f85632ea698$export$48a8e0809c5223e6)("worm")
};
// After a find you still have no bait, so "Dig again" is offered. After worms you
// hold your one handful, so those nodes only offer "Step away" (no pointless dig,
// and it sidesteps the option-render race on canHoldMore).
const $6e3c84ae2ea1dd92$var$AGAIN = {
    text: "Dig again.",
    nextDialogId: $6e3c84ae2ea1dd92$var$resolveDig,
    condition: ()=>(0, $2d3c1f85632ea698$export$48a8e0809c5223e6)("worm")
};
const $6e3c84ae2ea1dd92$var$AWAY = {
    text: "Step away.",
    nextDialogId: "start"
};
const $6e3c84ae2ea1dd92$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You stand at the foot of the old oak. The trunk is wide and rough, and the earth at its roots is dark and soft. Birds call from the branches above.",
        options: [
            $6e3c84ae2ea1dd92$var$DIG,
            {
                text: "Look up into the tree.",
                nextDialogId: "look_tree"
            }
        ]
    },
    // ~70% -- a handful of worms: one grant, three different reads. You have your
    // bait now, so these only step away.
    {
        id: "worms_a",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You push aside the wet earth at the oak's roots. The soil is dark and full of life. You fold **a handful of worms** into a leaf.",
        effects: [
            {
                type: "grant",
                item: "worm",
                quantity: 1
            }
        ],
        options: [
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "worms_b",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You turn the cool soil with your fingers. The worms twist away from the light, and you pick out the fattest. **A handful of worms**, wrapped and ready.",
        effects: [
            {
                type: "grant",
                item: "worm",
                quantity: 1
            }
        ],
        options: [
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "worms_c",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The ground lies soft in the shade of the oak. You dig, and the worms come up easily. Soon you have **a handful of worms** tucked away.",
        effects: [
            {
                type: "grant",
                item: "worm",
                quantity: 1
            }
        ],
        options: [
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    // ~30% -- a find *instead of* worms. Only the coin is kept; the rest are flavour
    // (no item enters the pack). You have no bait, so dig again.
    {
        id: "find_coin",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "Your fingers close on something small and hard. An old **denier**, green with age. Someone lost it here long before you.",
        effects: [
            {
                type: "grant",
                item: "coins",
                quantity: 1
            }
        ],
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "find_boot",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You pull up something stiff and heavy. A single old boot, packed with soil. The river gives up boots too. Where do they all come from? You leave it in the dirt.",
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "find_key",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "Cold iron turns up under your fingers. A heavy key, red with rust. It opens nothing you will ever find, so you drop it back.",
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "find_tooth",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "A yellow tooth works loose from the dirt, too big for any man. A pig's, most likely. They root everywhere in Beggen.",
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "find_squirrel",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You break into a neat store of acorns, a squirrel's whole winter. You have made an enemy for life, and cover it back over.",
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    {
        id: "find_whistle",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "A child's whistle, cut from a marsh reed and long gone soft. Some Dommeldange child must have dropped it, chasing something this far up the road.",
        options: [
            $6e3c84ae2ea1dd92$var$AGAIN,
            $6e3c84ae2ea1dd92$var$AWAY
        ]
    },
    // Flavour.
    {
        id: "look_tree",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The branches of the oak spread out wide. Small birds move from one to another. The tree must have stood here for a long time.",
        options: [
            {
                text: "Sit down at the foot of the tree.",
                nextDialogId: "rest"
            },
            $6e3c84ae2ea1dd92$var$DIG
        ]
    },
    {
        id: "rest",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "You sit with your back against the trunk. The bark is rough through your shirt. For a while, you do nothing at all.",
        options: [
            {
                text: "Stand up and step away.",
                nextDialogId: "start"
            }
        ]
    }
];


const $c4bc9ccd54d65020$export$617e858833feff13 = {
    id: "oak-beggen",
    name: "The oak tree",
    dialog: (0, $6e3c84ae2ea1dd92$export$518824cf31321346)
};




// Fast-day fish the priest will take, cheapest first (so the traveller keeps the
// better catch). Each fish has its own give-node so the consume effect stays static.
const $946ccf28adc789f6$var$FISH_ORDER = [
    "chub",
    "trout",
    "eel",
    "pike"
];
const $946ccf28adc789f6$var$GIVE_NODE_FOR_FISH = {
    chub: "give_chub",
    trout: "give_trout",
    eel: "give_eel",
    pike: "give_pike"
};
const $946ccf28adc789f6$var$hasAnyFish = ()=>$946ccf28adc789f6$var$FISH_ORDER.some((0, $2d3c1f85632ea698$export$5d8958bbf054854f));
// He gives the blessed charm once. The offer only shows while the traveller has a
// fish to give and does not yet carry the charm.
const $946ccf28adc789f6$var$canOfferFish = ()=>$946ccf28adc789f6$var$hasAnyFish() && !(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("charm");
// With no fish to give (and no charm yet), greeting him catches the priest
// muttering to himself about needing a fish for the fast day — an indirect hint
// to bring one. He does NOT mention the river here (the danger is only revealed
// when he gives the charm / when asked about the water).
const $946ccf28adc789f6$var$greetTarget = ()=>!(0, $2d3c1f85632ea698$export$5d8958bbf054854f)("charm") && !$946ccf28adc789f6$var$hasAnyFish() ? "mutter" : "greet";
const $946ccf28adc789f6$var$resolveGiveNode = ()=>{
    const fish = $946ccf28adc789f6$var$FISH_ORDER.find((0, $2d3c1f85632ea698$export$5d8958bbf054854f));
    return fish ? $946ccf28adc789f6$var$GIVE_NODE_FOR_FISH[fish] : "start";
};
// Seeing the traveller has been at the water, the priest blesses a small charm
// for protection (against the road, and the thing in the river) instead of coin.
const $946ccf28adc789f6$var$blessing = "You place the fish in his hands. He sees you have been by the water. 'There are things in that river best not met, my child. Take this charm. I have blessed it, and may Saint Willibrord keep you safe.'";
const $946ccf28adc789f6$var$giveNode = (fish)=>({
        id: $946ccf28adc789f6$var$GIVE_NODE_FOR_FISH[fish],
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: $946ccf28adc789f6$var$blessing,
        effects: [
            {
                type: "consume",
                item: fish,
                quantity: 1
            },
            {
                type: "grant",
                item: "charm",
                quantity: 1
            }
        ],
        options: [
            {
                text: "Thank you, father.",
                nextDialogId: "start"
            }
        ]
    });
const $946ccf28adc789f6$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The priest stands at the chapel door in a plain grey robe. He folds his hands when he sees you and waits with a calm face.",
        options: [
            {
                text: "Greet him.",
                nextDialogId: $946ccf28adc789f6$var$greetTarget
            },
            {
                text: "Ask about the chapel.",
                nextDialogId: "church"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Peace be with you, my child. By Saint Willibrord, it is good to see a traveller at this door.",
        options: [
            {
                text: "What do you do here?",
                nextDialogId: "church"
            },
            {
                text: "I have a fish for you, father.",
                nextDialogId: $946ccf28adc789f6$var$resolveGiveNode,
                condition: $946ccf28adc789f6$var$canOfferFish
            }
        ]
    },
    {
        id: "church",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "I tend this little chapel when my road brings me by. The parish church is a good walk from here, so the village sees a priest only now and then.",
        options: [
            {
                text: "Who do you answer to?",
                nextDialogId: "trier"
            },
            {
                text: "Why do you want fish?",
                nextDialogId: "fish_reason"
            }
        ]
    },
    {
        id: "trier",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "I answer to the Archbishop of Trier, my child, as the churches along the Alzette do. Trier is far, and the road is long, so most days it is only me and the saints.",
        options: [
            {
                text: "I see.",
                nextDialogId: "fish_reason"
            }
        ]
    },
    {
        id: "fish_reason",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "On a fast day we may not eat meat, so we eat fish instead. A fresh fish feeds a poor soul in the village, and there are always hungry mouths.",
        options: [
            {
                text: "Is the water safe?",
                nextDialogId: "creature"
            },
            {
                text: "Then take this fish, father.",
                nextDialogId: $946ccf28adc789f6$var$resolveGiveNode,
                condition: $946ccf28adc789f6$var$canOfferFish
            }
        ]
    },
    {
        id: "creature",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "They say a lady lives in the Alzette, half woman and half fish. She sings to men at the water and draws them under. I bless a charm for any soul who goes there, true or no.",
        options: [
            {
                text: "I have a fish for you, father.",
                nextDialogId: $946ccf28adc789f6$var$resolveGiveNode,
                condition: $946ccf28adc789f6$var$canOfferFish
            },
            {
                text: "I will take care.",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "mutter",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The priest does not seem to notice you. He worries to himself, half aloud. 'A fast day soon, and nothing in the pot. A fish would be a mercy, if anyone thought to bring one.' Then he sees you, and straightens.",
        options: [
            {
                text: "Greet him.",
                nextDialogId: "greet"
            },
            {
                text: "Leave him be.",
                nextDialogId: "start"
            }
        ]
    },
    $946ccf28adc789f6$var$giveNode("chub"),
    $946ccf28adc789f6$var$giveNode("trout"),
    $946ccf28adc789f6$var$giveNode("eel"),
    $946ccf28adc789f6$var$giveNode("pike")
];


const $cc9059b16299b2e8$export$88bd2043eb72d465 = {
    id: "priest-beggen",
    name: "Priest",
    dialog: (0, $946ccf28adc789f6$export$518824cf31321346)
};



const $daf4a0b8aa7c40e5$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "A man stands by an empty cottage, cutting fresh marks into a tally stick. He sees you, tucks it into his belt, and waves you over.",
        options: [
            {
                text: "Go to him.",
                nextDialogId: "greet"
            },
            {
                text: "Look over the empty house first.",
                nextDialogId: "house"
            }
        ]
    },
    {
        id: "house",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "The cottage sits shut and quiet. The hearth is cold, and the garden behind it has gone to weeds. No one has lived here for a year or more. The man watches you look, then speaks.",
        options: [
            {
                text: "(Turn to him.)",
                nextDialogId: "greet"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "I am the reeve here, the lord's man in Beggen. Houses and tenants are my charge. You have the look of someone who needs a roof, and here one stands with no one in it.",
        options: [
            {
                text: "Why does it stand empty?",
                nextDialogId: "empty"
            },
            {
                text: "You would give me a house?",
                nextDialogId: "offer"
            }
        ]
    },
    {
        id: "empty",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The family that held it is dead. The sickness took them last year, and half the village with them. My lord of Sankt Johannisberg has more empty houses now than people to fill them.",
        options: [
            {
                text: "And you would put me in one?",
                nextDialogId: "offer"
            }
        ]
    },
    {
        id: "offer",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Then take this **house**. You would hold it from the lord, not own it. Four walls, a door that shuts, and the garden plot behind. It is more than you have now.",
        options: [
            {
                text: "What must I pay?",
                nextDialogId: "terms"
            },
            {
                text: "I need time to think.",
                nextDialogId: "notyet"
            }
        ]
    },
    {
        id: "terms",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "A small sum to take it up, then a little rent each year. **Two sous** now, and two sous each autumn after. In fatter years I would ask more, but the lord wants the house lived in.",
        options: [
            {
                text: "I will take it.",
                nextDialogId: "accept"
            },
            {
                text: "It is still much for me.",
                nextDialogId: "haggle"
            }
        ]
    },
    {
        id: "haggle",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "The plague has left me more houses than takers, so I will not press you hard. One sou now, then. The rest can wait until your first harvest is in.",
        options: [
            {
                text: "Then I will take it.",
                nextDialogId: "accept"
            },
            {
                text: "Not yet.",
                nextDialogId: "notyet"
            }
        ]
    },
    {
        id: "accept",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        // TODO: a tenancy/holding is not yet an engine feature. When it exists, this
        // node should (a) take the entry fine from the player's coins and (b) mark the
        // player as the lord's tenant (grant the holding). A consume-coins effect
        // already exists in the model ({ type: 'consume', item: 'coins', quantity: N },
        // as used by the merchant), so the entry fine could hook in here as e.g.
        //   effects: [{ type: 'consume', item: 'coins', quantity: 24 /* 2 sous */ }, <grant holding>],
        // BUT do not wire the consume alone: the tree loops back to 'start' and there
        // is no holding flag to guard re-entry, so re-accepting would drain coins
        // repeatedly, and there is nothing to grant in return. Add tenancy state + an
        // affordability condition (see merchant's coins check) before enabling effects.
        text: "Done. I cut your mark on the tally, and it is settled. Welcome to Beggen, tenant. The house is yours to live in, so long as the rent is paid to the lord.",
        options: [
            {
                text: "My thanks.",
                nextDialogId: "start"
            }
        ]
    },
    {
        id: "notyet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "As you like. The house will keep a while yet. But the land does not wait forever, and a roof is a roof. Come find me when you have thought it over.",
        options: [
            {
                text: "I will.",
                nextDialogId: "start"
            }
        ]
    }
];


const $486c38233e78c2a0$export$7de6e9ae25ef26b6 = {
    id: "reeve-beggen",
    name: "Reeve",
    dialog: (0, $daf4a0b8aa7c40e5$export$518824cf31321346)
};



const $3d3614ece0e31abb$export$518824cf31321346 = [
    {
        id: "start",
        type: (0, $c525691551415870$export$290cb7291ee58b61).description,
        text: "A townswoman pauses with her basket and looks you over, curious.",
        options: [
            {
                text: "Greet her.",
                nextDialogId: "greet"
            },
            {
                text: "Ask what news there is.",
                nextDialogId: "news"
            }
        ]
    },
    {
        id: "greet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Welcome, traveller. A new face. We like a new face. It gives us something to talk about.",
        options: [
            {
                text: "What do folk talk about?",
                nextDialogId: "news"
            },
            {
                text: "A quiet town, then?",
                nextDialogId: "quiet"
            }
        ]
    },
    {
        id: "news",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "They say in the market that the count cares only for Prague now, and the Roman crown. And that the land will pass to his young brother one day.",
        options: [
            {
                text: "His brother?",
                nextDialogId: "heir"
            },
            {
                text: "Only market talk?",
                nextDialogId: "quiet"
            }
        ]
    },
    {
        id: "heir",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Wenceslaus, they call him. Still a boy, they say. Lords' business. It changes little for the likes of us.",
        options: [
            {
                text: "True enough.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "quiet",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Quiet enough. The well, the church, the market. A wedding when we are lucky. It suits me well.",
        options: [
            {
                text: "Sounds peaceful.",
                nextDialogId: "bye"
            }
        ]
    },
    {
        id: "bye",
        type: (0, $c525691551415870$export$290cb7291ee58b61).dialog,
        text: "Go well, traveller. Mind how you go.",
        options: [
            {
                text: "Leave.",
                nextDialogId: "start"
            }
        ]
    }
];


const $66e1bc1a4a899c89$export$23ad5af3eb043772 = {
    id: "townsfolk",
    name: "Townsfolk",
    dialog: (0, $3d3614ece0e31abb$export$518824cf31321346)
};


const $c6f20a8aba11b3fc$export$b027244a9b92ba3d = [
    (0, $7e1823c22ea3e407$export$de30803e26991d1c),
    (0, $17c98f18e7ce3a62$export$6424da03e6f0f8bf),
    (0, $e5c53dc42568747e$export$1c0eb4afad0324c7),
    (0, $792a456285edc44f$export$1a534d91e74f2da2),
    (0, $556f2ce50c13c8e1$export$6cb3f86b688595e),
    (0, $256c1187d600ce70$export$5ef0a1510acd70b2),
    (0, $66e1bc1a4a899c89$export$23ad5af3eb043772),
    (0, $e0de2594b7852815$export$a7b603ca93c48062),
    (0, $c4bc9ccd54d65020$export$617e858833feff13),
    (0, $05ecb4dd8c145330$export$a263b10ef1321bba),
    (0, $cc9059b16299b2e8$export$88bd2043eb72d465),
    (0, $486c38233e78c2a0$export$7de6e9ae25ef26b6)
];


const $7dc86ea3d04f3d15$export$f965ae91e38a1274 = [
    {
        id: "from-north-to-beggen-1",
        mapId: "0-0",
        pos: [
            955,
            196
        ],
        destination: [
            "from-north-to-beggen-2"
        ],
        spotlight: {
            title: "Beggen - Road up north",
            description: "The road ahead is long and turns out of sight. You are not sure you want to follow it."
        }
    },
    {
        id: "from-north-to-beggen-2",
        mapId: "0-0",
        pos: [
            953,
            259
        ],
        destination: [
            "from-north-to-beggen-1",
            "from-north-to-beggen-3"
        ],
        spotlight: {
            title: "Beggen - Road to Beggen",
            description: "The road is long. Beggen sits far ahead, small against the fields."
        }
    },
    {
        id: "from-north-to-beggen-3",
        mapId: "0-0",
        pos: [
            957,
            325
        ],
        destination: [
            "from-north-to-beggen-2",
            "from-north-to-beggen-4"
        ],
        spotlight: {
            title: "Beggen - Road to Beggen",
            description: "A cart has passed this way recently. Beggen is close enough that you can hear a dog barking."
        }
    },
    {
        id: "from-north-to-beggen-4",
        mapId: "0-0",
        pos: [
            961,
            391
        ],
        destination: [
            "from-north-to-beggen-3",
            "beggen-1"
        ],
        spotlight: {
            title: "Beggen - Northern edge",
            description: "The fields end here. Wooden fences and the first houses of Beggen begin. A crossroad waits a little further on."
        }
    },
    {
        id: "beggen-1",
        mapId: "0-0",
        pos: [
            971,
            473
        ],
        destination: [
            "from-north-to-beggen-4",
            "beggen-2"
        ],
        spotlight: {
            title: "Beggen - Northern crossroad",
            description: "An old wooden cross leans at the meeting of the roads. A crow watches you from the top of it."
        }
    },
    {
        id: "beggen-2",
        mapId: "0-0",
        pos: [
            1039,
            456
        ],
        destination: [
            "beggen-1",
            "beggen-3",
            "beggen-4"
        ],
        spotlight: {
            title: "Beggen - The lane",
            description: "Wooden houses lean against each other. A pig looks at you for a moment, then looks away."
        }
    },
    {
        id: "beggen-3",
        mapId: "0-0",
        pos: [
            1095,
            446
        ],
        destination: [
            "beggen-2",
            "beggen-4",
            "beggen-5"
        ],
        spotlight: {
            title: "Beggen - West of the village",
            description: "Wooden fences mark out a small yard beside the road. Through the pines, you can just see the corner of a house."
        }
    },
    {
        id: "beggen-4",
        mapId: "0-0",
        pos: [
            1074,
            414
        ],
        destination: [
            "beggen-3",
            "beggen-5"
        ],
        narratorId: "merchant-beggen",
        spotlight: {
            title: "Beggen - The merchant",
            description: "A wooden table stands outside a low house, half-covered in cloth, iron nails, and twists of dried herbs. The merchant watches over them from a stool."
        }
    },
    {
        id: "beggen-5",
        mapId: "0-0",
        pos: [
            1149,
            418
        ],
        destination: [
            "beggen-3",
            "beggen-4",
            "beggen-6",
            "beggen-7",
            "beggen-8"
        ],
        spotlight: {
            title: "Beggen - The village center",
            description: "You are standing in the middle of Beggen. It's a small town. Not much is going on."
        }
    },
    {
        id: "beggen-6",
        mapId: "0-0",
        pos: [
            1166,
            380
        ],
        destination: [
            "beggen-5",
            "beggen-8"
        ],
        narratorId: "priest-beggen",
        spotlight: {
            title: "Beggen - The chapel",
            description: "A small stone chapel stands close by the road. Its walls are patched against the weather, and no bell hangs over the low door."
        }
    },
    {
        id: "beggen-7",
        mapId: "0-0",
        pos: [
            1164,
            471
        ],
        destination: [
            "beggen-5",
            "beggen-8"
        ],
        spotlight: {
            title: "Beggen - The barn",
            description: "A barn of dark timber, its door barred. Sparrows have made themselves at home under the eaves."
        }
    },
    {
        id: "beggen-8",
        mapId: "0-0",
        pos: [
            1223,
            414
        ],
        destination: [
            "beggen-5",
            "beggen-6",
            "beggen-7",
            "beggen-9"
        ],
        spotlight: {
            title: "Beggen - East of the village",
            description: "The road runs east between low hedges. Not far away, you can hear the sound of running water."
        }
    },
    {
        id: "beggen-9",
        mapId: "0-0",
        pos: [
            1299,
            409
        ],
        destination: [
            "beggen-8",
            "beggen-10"
        ],
        spotlight: {
            title: "Beggen - East road",
            description: "A wooden fence runs along one side of the road. An old man sits against it, eyes closed, his dog asleep at his feet."
        }
    },
    {
        id: "beggen-10",
        mapId: "0-0",
        pos: [
            1361,
            403
        ],
        destination: [
            "beggen-9",
            "beggen-11"
        ],
        spotlight: {
            title: "Beggen - The bridge",
            description: "You are standing on the bridge leading into Beggen. The Alzette flows underneath. To the east, you can see a nice little fishing spot."
        }
    },
    {
        id: "beggen-11",
        mapId: "0-0",
        pos: [
            1417,
            392
        ],
        destination: [
            "beggen-10",
            "beggen-12",
            "beggen-13"
        ],
        spotlight: {
            title: "Beggen - East bank",
            description: "On this side of the bridge, a path drops down to the river. Another road continues east into the fields."
        }
    },
    {
        id: "beggen-12",
        mapId: "0-0",
        pos: [
            1419,
            451
        ],
        destination: [
            "beggen-11"
        ],
        spotlight: {
            title: "Beggen - The fishing spot",
            description: "A small, worn spot on the river bank, under the shade of an alder tree. A man stands in the shallow water, a fishing line in his hand. He looks up and gives you a friendly nod."
        },
        narratorId: "fisherman-beggen"
    },
    {
        id: "beggen-13",
        mapId: "0-0",
        pos: [
            1484,
            365
        ],
        destination: [
            "beggen-11",
            "beggen-14"
        ],
        spotlight: {
            title: "Beggen - East road",
            description: "The sound of the river is faint here. Wind moves through the long grass on either side of the road."
        }
    },
    {
        id: "beggen-14",
        mapId: "0-0",
        pos: [
            1564,
            364
        ],
        destination: [
            "beggen-13",
            "beggen-15"
        ],
        spotlight: {
            title: "Beggen - East crossroad",
            description: "A crossroad in the dirt. Roads lead off to the north and the south, into open country."
        }
    },
    {
        id: "beggen-15",
        mapId: "0-0",
        pos: [
            1617,
            388
        ],
        destination: [
            "beggen-14"
        ],
        spotlight: {
            title: "Beggen - The oak",
            description: "The oak tree is older than the road beside it. Insects move in its bark, and the earth around its roots is soft and dark."
        },
        narratorId: "oak-beggen"
    }
];


const $6528f9074d7b564d$export$b9c5bbe98d67049c = {
    startingPOI: "from-north-to-beggen-1",
    startingMap: "0-0",
    maps: [
        {
            id: "0-0",
            imagePath: "0-0.webp",
            size: [
                2500,
                2500
            ]
        }
    ]
};









var $22d95350298e069a$export$219d5638b1da6603;
(function(WorldEventBus) {
    WorldEventBus["initialise"] = "initialise";
})($22d95350298e069a$export$219d5638b1da6603 || ($22d95350298e069a$export$219d5638b1da6603 = {}));


const $1b4a0ec7083ea922$export$f4fbd3591474c250 = "builder-pois";
const $1b4a0ec7083ea922$export$2959bdb92460165a = 300;
var $1b4a0ec7083ea922$export$56fc3ce97a65a7bb;
(function(BuilderEventBus) {
    BuilderEventBus["toggle"] = "builderToggle";
})($1b4a0ec7083ea922$export$56fc3ce97a65a7bb || ($1b4a0ec7083ea922$export$56fc3ce97a65a7bb = {}));


class $883e35937f6e36a3$export$f75e4297694ec637 {
    constructor(){
        this.active = false;
        this.worldPOIs = (0, $7dc86ea3d04f3d15$export$f965ae91e38a1274);
        this.navigatorElement = document.querySelector(".js-navigator");
        this.longPressTimer = null;
        this.isPanning = false;
        this.panStartX = 0;
        this.panStartY = 0;
        this.panStartTranslateX = 0;
        this.panStartTranslateY = 0;
        this.pendingPOIPos = null;
        this.editingPOIId = null;
        this.lastEditedPOIId = null;
        this.boundMouseDown = this.onMouseDown.bind(this);
        this.boundMouseUp = this.onMouseUp.bind(this);
        this.boundMouseMove = this.onMouseMove.bind(this);
        this.createModal();
        this.setupControls();
        this.loadFromStorage();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, ()=>{
            this.worldElement = document.querySelector(".map-world");
        });
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).mapChanged, (mapId)=>{
            this.currentMapConfig = (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps.find((m)=>m.id === mapId) ?? (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps[0];
            this.worldElement = document.querySelector(".map-world");
        });
        document.addEventListener("keydown", (e)=>{
            if (e.key === "b" || e.key === "B") {
                if (this.modal.style.display !== "flex") this.toggle();
            }
            if (e.key === "Escape") this.closeModal();
        });
    }
    // ── Modal ──
    createModal() {
        this.modal = document.createElement("div");
        this.modal.className = "builder-modal";
        this.modal.style.display = "none";
        this.modal.innerHTML = `
      <div class="builder-modal__content">
        <h3 class="builder-modal__title">New POI</h3>
        <label>ID<input type="text" name="id" /></label>
        <label>Spotlight title<input type="text" name="spotlightTitle" /></label>
        <label>Spotlight description<input type="text" name="spotlightDesc" /></label>
        <label>Destinations <span style="font-size:10px;color:#666">(comma-separated IDs)</span><input type="text" name="destinations" /></label>
        <label>Narrator<select name="narratorId"><option value="">None</option></select></label>
        <div class="builder-modal__portal">
          <span style="font-size:12px;color:#aaa;">Portal</span>
          <div style="display:flex;gap:8px;">
            <label style="flex:1">Map<select name="portalMap"><option value="">None</option></select></label>
            <label style="flex:1">Target POI<input type="text" name="portalPOI" /></label>
          </div>
        </div>
        <div class="builder-modal__actions">
          <button class="builder-modal__delete" style="display:none">Delete</button>
          <span style="flex:1"></span>
          <button class="builder-modal__cancel">Cancel</button>
          <button class="builder-modal__save">Save</button>
        </div>
      </div>
    `;
        document.body.appendChild(this.modal);
        // Populate portal map dropdown
        const portalSelect = this.modal.querySelector('select[name="portalMap"]');
        (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps.forEach((m)=>{
            const opt = document.createElement("option");
            opt.value = m.id;
            opt.textContent = m.id;
            portalSelect.appendChild(opt);
        });
        // Populate narrator dropdown
        const narratorSelect = this.modal.querySelector('select[name="narratorId"]');
        (0, $c6f20a8aba11b3fc$export$b027244a9b92ba3d).forEach((n)=>{
            const opt = document.createElement("option");
            opt.value = n.id;
            opt.textContent = n.name;
            narratorSelect.appendChild(opt);
        });
        this.modal.querySelector(".builder-modal__cancel").addEventListener("click", ()=>this.closeModal());
        this.modal.querySelector(".builder-modal__save").addEventListener("click", ()=>this.saveModal());
        this.modal.querySelector(".builder-modal__delete").addEventListener("click", ()=>this.deleteModal());
        this.modal.addEventListener("click", (e)=>{
            if (e.target === this.modal) this.closeModal();
        });
    }
    openModalForNew(x, y) {
        this.pendingPOIPos = [
            x,
            y
        ];
        this.editingPOIId = null;
        const title = this.modal.querySelector(".builder-modal__title");
        title.textContent = "New POI";
        const deleteBtn = this.modal.querySelector(".builder-modal__delete");
        deleteBtn.style.display = "none";
        const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
        const lastPOI = currentMapPOIs[currentMapPOIs.length - 1];
        const nearest = this.findNearestPOI(x, y, Infinity);
        const suggestions = new Set();
        if (nearest) suggestions.add(nearest.id);
        if (lastPOI && lastPOI !== nearest) suggestions.add(lastPOI.id);
        this.getInput("id").value = this.getNextId();
        this.getInput("spotlightTitle").value = "";
        this.getInput("spotlightDesc").value = "";
        this.getInput("destinations").value = Array.from(suggestions).join(", ");
        this.getSelect("narratorId").value = "";
        this.getSelect("portalMap").value = "";
        this.getInput("portalPOI").value = "";
        this.modal.style.display = "flex";
        this.getInput("id").focus();
        this.getInput("id").select();
    }
    openModalForEdit(id) {
        const poi = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(id);
        if (!poi) return;
        this.pendingPOIPos = null;
        this.editingPOIId = id;
        const title = this.modal.querySelector(".builder-modal__title");
        title.textContent = `Edit: ${id}`;
        const deleteBtn = this.modal.querySelector(".builder-modal__delete");
        deleteBtn.style.display = "block";
        this.getInput("id").value = poi.id;
        this.getInput("spotlightTitle").value = poi.spotlight?.title || "";
        this.getInput("spotlightDesc").value = poi.spotlight?.description || "";
        this.getInput("destinations").value = poi.destination.join(", ");
        this.getSelect("narratorId").value = poi.narratorId || "";
        this.getSelect("portalMap").value = poi.portal?.targetMap || "";
        this.getInput("portalPOI").value = poi.portal?.targetPOI || "";
        this.modal.style.display = "flex";
        this.getInput("spotlightTitle").focus();
    }
    saveModal() {
        const id = this.getInput("id").value.trim();
        if (!id) return;
        const spotlightTitle = this.getInput("spotlightTitle").value.trim();
        const spotlightDesc = this.getInput("spotlightDesc").value.trim();
        const spotlight = spotlightTitle ? {
            title: spotlightTitle,
            description: spotlightDesc
        } : undefined;
        const destinations = this.getInput("destinations").value.split(",").map((d)=>d.trim()).filter(Boolean);
        const portalMap = this.getSelect("portalMap").value;
        const portalPOI = this.getInput("portalPOI").value.trim();
        const portal = portalMap && portalPOI ? {
            targetMap: portalMap,
            targetPOI: portalPOI
        } : undefined;
        const narratorId = this.getSelect("narratorId").value || undefined;
        if (this.editingPOIId) {
            const poi = this.worldPOIs.find((p)=>p.id === this.editingPOIId);
            if (poi) {
                const oldId = poi.id;
                poi.id = id;
                poi.spotlight = spotlight;
                poi.destination = destinations;
                poi.portal = portal;
                poi.narratorId = narratorId;
                if (oldId !== id) this.worldPOIs.forEach((p)=>{
                    p.destination = p.destination.map((d)=>d === oldId ? id : d);
                });
                console.log("Updated POI:", JSON.parse(JSON.stringify(poi)));
                this.lastEditedPOIId = id;
            }
        } else if (this.pendingPOIPos) {
            const newPOI = {
                id: id,
                mapId: this.currentMapConfig.id,
                pos: this.pendingPOIPos,
                destination: destinations,
                ...spotlight && {
                    spotlight: spotlight
                },
                ...portal && {
                    portal: portal
                },
                ...narratorId && {
                    narratorId: narratorId
                }
            };
            // Auto-link: add this POI to the destination list of linked POIs
            destinations.forEach((destId)=>{
                const destPOI = this.worldPOIs.find((p)=>p.id === destId);
                if (destPOI && !destPOI.destination.includes(id)) destPOI.destination.push(id);
            });
            this.worldPOIs.push(newPOI);
            console.log("Added POI:", JSON.parse(JSON.stringify(newPOI)));
            this.centerOnPOI(newPOI);
            this.lastEditedPOIId = newPOI.id;
        }
        this.saveToStorage();
        this.rebuildMarkers();
        this.closeModal();
    }
    deleteModal() {
        if (!this.editingPOIId) return;
        const id = this.editingPOIId;
        // Remove destination references to this POI from other POIs
        this.worldPOIs.forEach((p)=>{
            p.destination = p.destination.filter((d)=>d !== id);
        });
        // Remove the POI itself
        const idx = this.worldPOIs.findIndex((p)=>p.id === id);
        if (idx !== -1) {
            this.worldPOIs.splice(idx, 1);
            console.log("Deleted POI:", id);
        }
        if (this.lastEditedPOIId === id) this.lastEditedPOIId = null;
        this.saveToStorage();
        this.rebuildMarkers();
        this.closeModal();
    }
    closeModal() {
        this.modal.style.display = "none";
        this.pendingPOIPos = null;
        this.editingPOIId = null;
    }
    getInput(name) {
        return this.modal.querySelector(`input[name="${name}"]`);
    }
    getSelect(name) {
        return this.modal.querySelector(`select[name="${name}"]`);
    }
    // ── Controls ──
    setupControls() {
        const controls = document.querySelector(".builder-controls");
        if (!controls) return;
        controls.style.display = "flex";
        this.toggleButton = controls.querySelector(".builder-toggle");
        this.exportButton = controls.querySelector(".builder-export");
        this.toggleButton.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.toggle();
        });
        this.exportButton.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.exportToClipboard();
        });
    }
    toggle() {
        this.active = !this.active;
        this.toggleButton.classList.toggle("is-active", this.active);
        document.body.classList.toggle("builder-active", this.active);
        if (this.active) {
            this.navigatorElement.addEventListener("mousedown", this.boundMouseDown);
            this.navigatorElement.addEventListener("touchstart", this.boundMouseDown);
        } else {
            this.navigatorElement.removeEventListener("mousedown", this.boundMouseDown);
            this.navigatorElement.removeEventListener("touchstart", this.boundMouseDown);
            this.cleanupPan();
            this.startOnLastPOI();
        }
    }
    // ── Event handling ──
    onMouseDown(event) {
        if (event.target.closest(".builder-controls")) return;
        if (this.modal.style.display === "flex") return;
        event.preventDefault();
        event.stopPropagation();
        const { clientX: clientX, clientY: clientY } = this.getClientXY(event);
        this.longPressTimer = setTimeout(()=>{
            this.startPan(clientX, clientY);
        }, (0, $1b4a0ec7083ea922$export$2959bdb92460165a));
        document.addEventListener("mouseup", this.boundMouseUp);
        document.addEventListener("touchend", this.boundMouseUp);
        document.addEventListener("mousemove", this.boundMouseMove);
        document.addEventListener("touchmove", this.boundMouseMove);
    }
    onMouseUp(event) {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
            const { clientX: clientX, clientY: clientY } = this.getClientXY(event);
            this.handleClick(clientX, clientY);
        }
        this.cleanupPan();
        document.removeEventListener("mouseup", this.boundMouseUp);
        document.removeEventListener("touchend", this.boundMouseUp);
        document.removeEventListener("mousemove", this.boundMouseMove);
        document.removeEventListener("touchmove", this.boundMouseMove);
    }
    onMouseMove(event) {
        if (this.isPanning) {
            const { clientX: clientX, clientY: clientY } = this.getClientXY(event);
            const dx = clientX - this.panStartX;
            const dy = clientY - this.panStartY;
            this.worldElement.style.transition = "none";
            this.worldElement.style.transform = `translate(${this.panStartTranslateX + dx}px, ${this.panStartTranslateY + dy}px)`;
        }
    }
    // ── Pan ──
    startPan(clientX, clientY) {
        this.longPressTimer = null;
        this.isPanning = true;
        this.panStartX = clientX;
        this.panStartY = clientY;
        const transform = this.worldElement.style.transform;
        const match = transform.match(/translate\((-?[\d.]+)px,\s*(-?[\d.]+)px\)/);
        this.panStartTranslateX = match ? parseFloat(match[1]) : 0;
        this.panStartTranslateY = match ? parseFloat(match[2]) : 0;
        this.worldElement.style.cursor = "grabbing";
    }
    cleanupPan() {
        this.isPanning = false;
        if (this.worldElement) {
            this.worldElement.style.cursor = "";
            this.worldElement.style.transition = "";
        }
    }
    // ── Click handling ──
    clientToMapCoords(clientX, clientY) {
        const rect = this.worldElement.getBoundingClientRect();
        const scaleX = this.currentMapConfig.size[0] / rect.width;
        const scaleY = this.currentMapConfig.size[1] / rect.height;
        return [
            Math.floor((clientX - rect.left) * scaleX),
            Math.floor((clientY - rect.top) * scaleY)
        ];
    }
    findNearestPOI(mapX, mapY, maxRadius = 30) {
        const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
        let nearest = null;
        let nearestDist = Infinity;
        for (const poi of currentMapPOIs){
            const dx = poi.pos[0] - mapX;
            const dy = poi.pos[1] - mapY;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < maxRadius && dist < nearestDist) {
                nearest = poi;
                nearestDist = dist;
            }
        }
        return nearest;
    }
    handleClick(clientX, clientY) {
        const [mapX, mapY] = this.clientToMapCoords(clientX, clientY);
        const hitPOI = this.findNearestPOI(mapX, mapY);
        if (hitPOI) {
            console.log("POI:", JSON.parse(JSON.stringify(hitPOI)));
            this.openModalForEdit(hitPOI.id);
        } else this.openModalForNew(mapX, mapY);
    }
    // ── Helpers ──
    centerOnPOI(poi) {
        const viewport = this.navigatorElement.getBoundingClientRect();
        const translateX = -(poi.pos[0] - viewport.width / 2);
        const translateY = -(poi.pos[1] - viewport.height * 0.72);
        this.worldElement.style.transition = "transform 500ms ease-in-out";
        this.worldElement.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
    getNextId() {
        const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
        if (currentMapPOIs.length === 0) return "poi-1";
        const lastId = currentMapPOIs[currentMapPOIs.length - 1].id;
        const match = lastId.match(/^(.*-)(\d+)$/);
        if (match) return `${match[1]}${parseInt(match[2]) + 1}`;
        return `${lastId}-1`;
    }
    rebuildMarkers() {
        this.worldElement.querySelectorAll(".map-world__marker").forEach((el)=>el.remove());
        const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
        currentMapPOIs.forEach(({ id: id, pos: pos })=>{
            const marker = document.createElement("div");
            marker.className = "map-world__marker";
            marker.style.left = `${pos[0]}px`;
            marker.style.top = `${pos[1]}px`;
            marker.innerHTML = `<div id="${id}" class="map-world__marker-dot"></div>`;
            this.worldElement.appendChild(marker);
        });
    }
    saveToStorage() {
        const data = this.worldPOIs.map(({ id: id, mapId: mapId, pos: pos, destination: destination, spotlight: spotlight, narratorId: narratorId, portal: portal })=>({
                id: id,
                mapId: mapId,
                pos: pos,
                destination: destination,
                ...spotlight && {
                    spotlight: spotlight
                },
                ...narratorId && {
                    narratorId: narratorId
                },
                ...portal && {
                    portal: portal
                }
            }));
        localStorage.setItem((0, $1b4a0ec7083ea922$export$f4fbd3591474c250), JSON.stringify(data));
    }
    loadFromStorage() {
        const stored = localStorage.getItem((0, $1b4a0ec7083ea922$export$f4fbd3591474c250));
        if (!stored) return;
        const pois = JSON.parse(stored);
        if (Array.isArray(pois) && pois.length > 0) {
            this.worldPOIs.length = 0;
            pois.forEach((p)=>this.worldPOIs.push(p));
        }
    }
    exportToClipboard() {
        const esc = (s)=>s.replace(/\\/g, "\\\\").replace(/'/g, "\\'");
        const lines = this.worldPOIs.map((p)=>{
            const parts = [
                `    id: '${esc(p.id)}'`,
                `    mapId: '${esc(p.mapId)}'`,
                `    pos: [${p.pos[0]}, ${p.pos[1]}]`,
                `    destination: [${p.destination.map((d)=>`'${esc(d)}'`).join(", ")}]`
            ];
            if (p.spotlight) parts.push(`    spotlight: { title: '${esc(p.spotlight.title)}', description: '${esc(p.spotlight.description)}' }`);
            if (p.narratorId) parts.push(`    narratorId: '${esc(p.narratorId)}'`);
            if (p.portal) parts.push(`    portal: { targetMap: '${esc(p.portal.targetMap)}', targetPOI: '${esc(p.portal.targetPOI)}' }`);
            return `  {\n${parts.join(",\n")},\n  }`;
        });
        const ts = `export const world: POI[] = [\n${lines.join(",\n")},\n];\n`;
        navigator.clipboard.writeText(ts).then(()=>console.log("Exported to clipboard!"), (err)=>console.error("Clipboard write failed:", err));
    }
    startOnLastPOI() {
        // Prefer the most recently edited POI; fall back to the last POI on the current map.
        let targetPOI;
        if (this.lastEditedPOIId && this.worldPOIs.some((p)=>p.id === this.lastEditedPOIId)) targetPOI = this.lastEditedPOIId;
        else {
            const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
            targetPOI = currentMapPOIs[currentMapPOIs.length - 1]?.id;
        }
        if (!targetPOI) return;
        this.worldElement?.remove();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $22d95350298e069a$export$219d5638b1da6603).initialise, targetPOI);
    }
    getClientXY(event) {
        if (event instanceof MouseEvent) return {
            clientX: event.clientX,
            clientY: event.clientY
        };
        const touch = event.touches[0] || event.changedTouches[0];
        return {
            clientX: touch.clientX,
            clientY: touch.clientY
        };
    }
}






class $8701a593c206eaf6$export$67348c0c68d77a13 {
    constructor(reader){
        this.reader = reader;
        this.element = document.querySelector(".js-carry-hud");
        this.quantities = {};
        this.quantities = this.snapshot();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $f5ff537df8440e15$export$af1a6ad62b6fae06).changed, ()=>this.onChange());
        this.render();
    }
    snapshot() {
        const owned = this.reader.getState().items;
        const snap = {};
        for (const id of Object.keys(owned))if (!(0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id]?.hideInInventory) snap[id] = owned[id];
        return snap;
    }
    onChange() {
        const next = this.snapshot();
        const ids = new Set([
            ...Object.keys(this.quantities),
            ...Object.keys(next)
        ]);
        const moved = [
            ...ids
        ].some((id)=>(this.quantities[id] ?? 0) !== (next[id] ?? 0));
        if (moved) this.bump();
        this.quantities = next;
        this.render();
    }
    // Restart the pulse animation (remove + reflow + re-add) so rapid pickups
    // each get their own bump rather than being swallowed mid-animation.
    bump() {
        if (!this.element) return;
        this.element.classList.remove("is-bump");
        this.element.offsetWidth;
        this.element.classList.add("is-bump");
    }
    vessel() {
        return this.reader.getState().items.backpack ? "\uD83C\uDF92" : "\uD83D\uDC5C";
    }
    render() {
        if (!this.element) return;
        const state = this.reader.getState();
        const total = (0, $c154c7fb9f805405$export$b7ff8ddbad63f099) + (0, $c154c7fb9f805405$export$de7d27adbe6f40ec)(state);
        this.element.textContent = `${this.vessel()} ${(0, $c154c7fb9f805405$export$c5efcc30107f1083)((0, $c154c7fb9f805405$export$de32fe5d64aee40c)(state))}/${total}`;
    }
}


// Money is stored as a count of deniers. Display it in the period livre/sou/denier
// system: 12 deniers = 1 sou, 20 sous = 1 livre (= 240 deniers).
const $3241912be5cdfff0$export$ab587cbb5c158cb = 12;
const $3241912be5cdfff0$export$706d4e8cdd40c9e5 = 240;
function $3241912be5cdfff0$export$a17b3c2052469c69(deniers) {
    const total = Math.max(0, Math.floor(deniers));
    const livre = Math.floor(total / $3241912be5cdfff0$export$706d4e8cdd40c9e5);
    const sou = Math.floor(total % $3241912be5cdfff0$export$706d4e8cdd40c9e5 / $3241912be5cdfff0$export$ab587cbb5c158cb);
    const den = total % $3241912be5cdfff0$export$ab587cbb5c158cb;
    const parts = [];
    if (livre) parts.push(`${livre}l`);
    if (sou) parts.push(`${sou}s`);
    if (den || parts.length === 0) parts.push(`${den}d`);
    return parts.join(" ");
}




class $b54f58e47b08eeb3$export$fe8a79e1b6b59a8c {
    constructor(reader){
        this.reader = reader;
        this.element = document.querySelector(".js-coin-hud");
        this.coins = 0;
        this.coins = this.amount();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $f5ff537df8440e15$export$af1a6ad62b6fae06).changed, ()=>this.onChange());
        this.render();
    }
    amount() {
        return this.reader.getState().items.coins ?? 0;
    }
    onChange() {
        const amount = this.amount();
        if (amount !== this.coins) this.bump();
        this.coins = amount;
        this.render();
    }
    // Restart the pulse (remove + reflow + re-add) so successive changes each bump.
    bump() {
        if (!this.element) return;
        this.element.classList.remove("is-bump");
        this.element.offsetWidth;
        this.element.classList.add("is-bump");
    }
    render() {
        if (!this.element) return;
        this.element.textContent = `\u{1FA99} ${(0, $3241912be5cdfff0$export$a17b3c2052469c69)(this.amount())}`;
    }
}


// Full-screen title/splash screen shown over the game on load. It sits inside
// the phone "screen" (so on desktop it stays within the device frame) and is
// dismissed by the Play button, revealing the already-booted game underneath.
class $cca8b0afb9b18424$export$b3c44ac484b3c461 {
    constructor(){
        this.element = document.querySelector(".js-intro");
        this.play = document.querySelector(".js-intro-play");
        this.play?.addEventListener("click", ()=>this.dismiss());
    }
    dismiss() {
        if (this.element) this.element.hidden = true;
    }
}







class $de4762133797aa2a$export$b68637424d278e7c {
    constructor(reader){
        this.reader = reader;
        this.panel = document.querySelector(".js-inventory");
        this.list = document.querySelector(".js-inventory-items");
        this.toggle = document.querySelector(".js-carry-hud");
        this.close = document.querySelector(".js-inventory-close");
        this.selectedId = null;
        this.toggle?.addEventListener("click", ()=>this.togglePanel());
        this.close?.addEventListener("click", ()=>this.hidePanel());
        this.list?.addEventListener("click", (event)=>this.onRowClick(event));
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $f5ff537df8440e15$export$af1a6ad62b6fae06).changed, ()=>this.render());
        this.render();
    }
    togglePanel() {
        if (!this.panel) return;
        this.panel.hidden = !this.panel.hidden;
    }
    hidePanel() {
        if (this.panel) this.panel.hidden = true;
    }
    onRowClick(event) {
        const row = event.target.closest(".inventory__item");
        const id = row?.dataset.itemId;
        if (!id) return;
        this.selectedId = id;
        this.render();
    }
    render() {
        if (!this.list) return;
        const state = this.reader.getState();
        const rows = Object.keys((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)).map((id)=>({
                id: id,
                name: (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].name,
                quantity: state.items[id] ?? 0
            })).filter((row)=>row.quantity > 0 && !(0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[row.id].hideInInventory);
        // Default to the first item (and recover if the selected one is gone) so a
        // description is always shown — which makes it clear items can be inspected.
        if (!rows.some((row)=>row.id === this.selectedId)) this.selectedId = rows[0]?.id ?? null;
        this.list.innerHTML = "";
        const bonus = (0, $c154c7fb9f805405$export$de7d27adbe6f40ec)(state);
        const load = document.createElement("div");
        load.className = "inventory__load";
        load.appendChild(document.createTextNode(`Load: ${(0, $c154c7fb9f805405$export$c5efcc30107f1083)((0, $c154c7fb9f805405$export$de32fe5d64aee40c)(state))}/${(0, $c154c7fb9f805405$export$b7ff8ddbad63f099) + bonus}`));
        if (bonus > 0) {
            const bonusEl = document.createElement("span");
            bonusEl.className = "inventory__load-bonus";
            bonusEl.textContent = ` (\u{1F392} +${bonus})`;
            bonusEl.title = "from backpack";
            load.appendChild(bonusEl);
        }
        this.list.appendChild(load);
        if (rows.length === 0) {
            const empty = document.createElement("div");
            empty.className = "inventory__empty";
            empty.textContent = "Empty";
            this.list.appendChild(empty);
            return;
        }
        const table = document.createElement("table");
        table.className = "inventory__table";
        const head = document.createElement("tr");
        const cols = [
            [
                "\uD83D\uDCE6",
                "inventory__col-item",
                "Item"
            ],
            [
                "\u2696",
                "inventory__col-weight",
                "Weight"
            ],
            [
                "#",
                "inventory__col-qty",
                "Quantity"
            ]
        ];
        for (const [text, cls, title] of cols){
            const th = document.createElement("th");
            th.className = cls;
            th.textContent = text;
            if (title) th.title = title;
            head.appendChild(th);
        }
        const thead = document.createElement("thead");
        thead.appendChild(head);
        table.appendChild(thead);
        const tbody = document.createElement("tbody");
        for (const row of rows){
            const tr = document.createElement("tr");
            tr.className = "inventory__item";
            tr.setAttribute("data-item-id", row.id);
            if (row.id === this.selectedId) tr.classList.add("is-selected");
            const name = document.createElement("td");
            name.className = "inventory__item-label";
            name.textContent = row.name;
            const qty = document.createElement("td");
            qty.className = "inventory__item-qty";
            qty.textContent = String(row.quantity);
            const weight = document.createElement("td");
            weight.className = "inventory__item-weight";
            const totalWeight = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[row.id].weight * row.quantity;
            // Weightless goods (e.g. the rod) show nothing rather than a bare "0".
            weight.textContent = totalWeight > 0 ? (0, $c154c7fb9f805405$export$c5efcc30107f1083)(totalWeight) : "";
            tr.append(name, weight, qty);
            tbody.appendChild(tr);
        }
        table.appendChild(tbody);
        this.list.appendChild(table);
        if (this.selectedId) {
            const detail = document.createElement("div");
            detail.className = "inventory__detail js-inventory-detail";
            const detailName = document.createElement("div");
            detailName.className = "inventory__detail-name";
            detailName.textContent = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[this.selectedId].name;
            const detailText = document.createElement("p");
            detailText.className = "inventory__detail-text";
            detailText.textContent = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[this.selectedId].description;
            detail.append(detailName, detailText);
            this.list.appendChild(detail);
        }
    }
}


class $817acb2f43511c23$export$ea74da9b5c8c37e4 {
    constructor(autosave){
        this.autosave = autosave;
    }
    load() {
        const stored = this.autosave.autosaveValue;
        return {
            items: stored?.items ?? {}
        };
    }
    save(state) {
        this.autosave.save({
            items: state.items
        });
    }
}






class $d5d235cae94184b7$export$9d532498ede20ce1 {
    constructor(){
        this.navigatorElement = document.querySelector(".js-navigator");
        this.joystickElement = document.querySelector(".js-joystick-integrated");
        this.activeClass = "is-active";
        this.backdropElement = document.querySelector(".device");
        this.screenElement = document.querySelector(".device__screen");
        this.heroElement = document.querySelector(".hero");
        this.directions = [];
        this.hasNavigated = false;
        this.isMousePressed = false;
        this.lastX = 0;
        this.lastY = 0;
        this.lastMoveEvent = null;
        this.directionThreshold = 20;
        /** Horseback (future feature): when true, holding the joystick toward an exit
   * keeps moving the player POI-by-POI without releasing. Off by default, so a
   * move commits once and the joystick disappears the moment it does; the player
   * must release and press again to move again — but they can do so straight
   * away, without waiting for the hero to arrive. */ this.continuousMovement = false;
        /** The current press's live drag listeners, stored so they can be detached
   * reliably from any teardown site (release, navigation end). */ this.activeMoveHandler = null;
        this.activeEndHandler = null;
        /** While the knob is held at the rim toward a valid exit, the move "charges"
   * for this long before it commits; the ring fill is animated over the same
   * duration in CSS (.is-charging). Keep the two in sync. */ this.chargingClass = "is-charging";
        this.chargeDurationMs = 1000;
        this.chargeTimer = null;
        this.chargingDestination = null;
        this.initializeEventListeners();
    }
    static getInstance() {
        if (!$d5d235cae94184b7$export$9d532498ede20ce1.instance) $d5d235cae94184b7$export$9d532498ede20ce1.instance = new $d5d235cae94184b7$export$9d532498ede20ce1();
        return $d5d235cae94184b7$export$9d532498ede20ce1.instance;
    }
    initializeEventListeners() {
        this.handleJoystickNavigation();
        this.handleBackdropPress();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, (poi)=>this.setAvailableDirections(poi));
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationEnd, (poi)=>this.onNavigationEnd(poi));
    }
    /**
   * Backdrop (desktop only): a press on the dark area around the phone frame
   * starts the joystick exactly as a press on the map does, so the whole window
   * is a valid place to begin a drag. Presses on the map are left to the
   * navigator's own listener, and presses on in-phone UI (buttons, etc.) are
   * left alone — only true backdrop presses start a drag here.
   */ handleBackdropPress() {
        const { backdropElement: backdropElement } = this;
        if (!backdropElement) return;
        const startFromBackdrop = (event)=>{
            const target = event.target;
            // Map presses bubble up here too; the navigator starts those itself.
            if (target && this.navigatorElement.contains(target)) return;
            // Leave in-phone UI (narrator, merchant, inventory…) its own clicks.
            if (this.isInsideScreen(event)) return;
            this.startEvent(event);
        };
        backdropElement.addEventListener("mousedown", startFromBackdrop);
        backdropElement.addEventListener("touchstart", startFromBackdrop);
    }
    /** True when a pointer event lands within the phone screen's box. */ isInsideScreen(event) {
        if (!this.screenElement) return false;
        const rect = this.screenElement.getBoundingClientRect();
        const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        const clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    }
    handleJoystickNavigation() {
        this.navigatorElement.addEventListener("mousedown", this.startEvent.bind(this));
        this.navigatorElement.addEventListener("touchstart", this.startEvent.bind(this));
    }
    startEvent(event) {
        // Defensive: drop any listeners left over from a press that didn't clean up.
        this.removeInteractionListeners();
        this.isMousePressed = true;
        const { x: x, y: y, rect: rect } = this.getEventCoordinates(event);
        // The joystick is drawn centred on the player's on-screen position (the hero
        // dot), not the press point, so the knob and charge ring stay visible rather
        // than hidden under the finger. The press point is still the drag origin
        // (see handleMoveEvent), so the knob tracks the drag direction and distance.
        // Reset the hero to its true centre first so the circle is measured against
        // the resting position, not a leftover knob displacement.
        if (this.heroElement) this.heroElement.style.transform = "translate(0, 0)";
        this.centreJoystickOnPlayer();
        this.joystickElement.classList.add(this.activeClass);
        const moveEvent = this.createMoveEventHandler(x, y, rect);
        const endEvent = ()=>this.endInteraction();
        this.activeMoveHandler = moveEvent;
        this.activeEndHandler = endEvent;
        document.addEventListener("mousemove", moveEvent);
        document.addEventListener("mouseup", endEvent);
        document.addEventListener("touchmove", moveEvent);
        document.addEventListener("touchend", endEvent);
    }
    getEventCoordinates(event) {
        const rect = this.navigatorElement.getBoundingClientRect();
        const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        const clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        const x = clientX - rect.left;
        const y = clientY - rect.top;
        return {
            x: x,
            y: y,
            rect: rect
        };
    }
    setJoystickPosition(x, y) {
        const translateX = x - this.joystickElement.offsetWidth / 2;
        const translateY = y - this.joystickElement.offsetHeight / 2;
        this.joystickElement.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
    /** Centres the joystick on the hero dot's current viewport position. The hero
   * stays at a fixed on-screen spot (it doesn't move as the camera pans), so this
   * is stable across navigation and works on both the desktop frame and mobile. */ centreJoystickOnPlayer() {
        if (!this.heroElement) return;
        const rect = this.heroElement.getBoundingClientRect();
        this.setJoystickPosition(rect.left + rect.width / 2, rect.top + rect.height / 2);
    }
    createMoveEventHandler(x, y, rect) {
        return (moveEvent)=>{
            this.lastX = x;
            this.lastY = y;
            this.lastMoveEvent = moveEvent;
            const moveClientX = moveEvent instanceof MouseEvent ? moveEvent.clientX : moveEvent.touches[0].clientX;
            const moveClientY = moveEvent instanceof MouseEvent ? moveEvent.clientY : moveEvent.touches[0].clientY;
            this.handleMoveEvent(moveClientX, moveClientY, x, y, rect);
        };
    }
    handleMoveEvent(moveClientX, moveClientY, x, y, rect) {
        if (!this.heroElement) return;
        let moveX = moveClientX - rect.left - x;
        let moveY = moveClientY - rect.top - y;
        const distance = Math.sqrt(moveX * moveX + moveY * moveY);
        const maxDistance = (this.joystickElement.offsetWidth - this.heroElement.offsetWidth) / 2;
        let atRim = false;
        let angle = 0;
        if (distance > maxDistance) {
            angle = Math.atan2(moveY, moveX);
            moveX = Math.cos(angle) * maxDistance;
            moveY = Math.sin(angle) * maxDistance;
            atRim = true;
        }
        // The hero dot itself is the knob: it slides within the circle to show the
        // drag, instead of a separate marker.
        this.heroElement.style.transform = `translate(${moveX}px, ${moveY}px)`;
        // Held at the rim toward a valid exit → charge; anything else disarms. Once a
        // move has committed for this press, stay disarmed until navigation ends.
        if (atRim && !this.hasNavigated) this.updateCharge(this.resolveDestination(angle * (180 / Math.PI)));
        else this.cancelCharge();
    }
    /**
   * Arms or sustains the 1s charge toward `destination`. A null destination (no
   * exit within the angular threshold) disarms. A *changed* destination restarts
   * the charge so the ring fill always reflects the move about to commit.
   */ updateCharge(destination) {
        if (!destination) {
            this.cancelCharge();
            return;
        }
        if (destination === this.chargingDestination) return;
        const heading = this.directions.find((direction)=>direction.destination === destination)?.angle ?? 0;
        this.startCharge(destination, heading);
    }
    startCharge(destination, headingDegrees) {
        this.cancelCharge();
        this.chargingDestination = destination;
        // Begin the ring fill at the heading so it emanates from the direction of travel.
        this.joystickElement.style.setProperty("--charge-angle", `${headingDegrees}deg`);
        // Re-add the class after a reflow so the ring fill replays from empty.
        this.joystickElement.offsetWidth;
        this.joystickElement.classList.add(this.chargingClass);
        this.chargeTimer = setTimeout(()=>this.commitCharge(), this.chargeDurationMs);
    }
    commitCharge() {
        const destination = this.chargingDestination;
        this.cancelCharge();
        if (!destination) return;
        this.navigate(destination);
        this.hasNavigated = true;
        // Horseback (future): the finger stays live and re-charges on arrival.
        if (this.continuousMovement) return;
        // The hero is on its way, so the joystick goes away now rather than on
        // arrival: the player can press again and charge the next move while the
        // camera is still panning. The committing finger is spent — its listeners
        // are detached, so holding it does nothing until it is released and pressed
        // again.
        this.endInteraction();
        // Aim at the exits of the POI being travelled to: a charge started during
        // travel must resolve against where the hero is going, not where it left.
        this.aimAtDestination(destination);
    }
    /**
   * Points the joystick at `destination`'s exits for the duration of the
   * travel. A portal destination is the exception: it swaps the map mid-flight,
   * so the exits it lists are unreachable by the time the hero lands. Offering
   * none is better than offering wrong ones — the player would spend a full
   * charge on a move the Navigator then refuses. navigationEnd repopulates them
   * from the POI actually landed on.
   */ aimAtDestination(destination) {
        if ((0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(destination)?.portal) {
            this.directions = [];
            return;
        }
        this.setAvailableDirections(destination);
    }
    cancelCharge() {
        if (this.chargeTimer !== null) {
            clearTimeout(this.chargeTimer);
            this.chargeTimer = null;
        }
        this.chargingDestination = null;
        this.joystickElement.classList.remove(this.chargingClass);
    }
    /**
   * Maps a heading (degrees, atan2 convention: 0 = right, 90 = down) to the
   * best-matching available destination. Shared by the drag joystick, the
   * clickable direction arrows and the backdrop clicks so direction→POI
   * resolution lives in exactly one place. Returns null if no exit is within
   * the angular threshold.
   */ resolveDestination(angleDegrees) {
        let best = null;
        let bestDiff = this.directionThreshold;
        this.directions.forEach((direction)=>{
            const diff = this.angleDelta(angleDegrees, direction.angle);
            if (diff <= bestDiff) {
                bestDiff = diff;
                best = direction.destination;
            }
        });
        return best;
    }
    /** Smallest absolute difference between two angles in degrees (handles wrap). */ angleDelta(a, b) {
        const diff = Math.abs(a - b) % 360;
        return diff > 180 ? 360 - diff : diff;
    }
    /** Detaches the current press's drag listeners and clears their references.
   * Safe to call when no interaction is active. */ removeInteractionListeners() {
        if (this.activeMoveHandler) {
            document.removeEventListener("mousemove", this.activeMoveHandler);
            document.removeEventListener("touchmove", this.activeMoveHandler);
        }
        if (this.activeEndHandler) {
            document.removeEventListener("mouseup", this.activeEndHandler);
            document.removeEventListener("touchend", this.activeEndHandler);
        }
        this.activeMoveHandler = null;
        this.activeEndHandler = null;
    }
    /** Tears the joystick down: cancels any charge, fades out the ring/knob
   * (removes is-active), snaps the hero dot back to centre and detaches the
   * drag listeners. Idempotent — safe on release, navigation end or a stray
   * call. */ endInteraction() {
        this.isMousePressed = false;
        this.cancelCharge();
        this.joystickElement.classList.remove(this.activeClass);
        // Snap the hero dot back to the player's true centre.
        if (this.heroElement) this.heroElement.style.transform = "translate(0, 0)";
        this.removeInteractionListeners();
    }
    onNavigationEnd(poi) {
        this.setAvailableDirections(poi);
        // Horseback (future): if the joystick is still held toward a valid exit when
        // the move finishes, re-evaluate the drag and keep moving.
        if (this.continuousMovement) {
            this.hasNavigated = false;
            if (this.isMousePressed && this.lastMoveEvent) {
                const rect = this.navigatorElement.getBoundingClientRect();
                const moveEvent = this.createMoveEventHandler(this.lastX, this.lastY, rect);
                moveEvent(this.lastMoveEvent);
            }
            return;
        }
    // Default: nothing to tear down here — the joystick was dismissed the
    // moment the move committed. Arrival must leave a press started during
    // travel alone, or it would cancel a charge already under way. The refresh
    // above is still worth doing: it corrects the optimistic aim taken at
    // commit (portal transitions land somewhere else entirely).
    }
    setAvailableDirections(currentPoi) {
        this.hasNavigated = false;
        this.directions = [];
        const poi = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(currentPoi);
        const poiElement = document.getElementById(currentPoi);
        poi?.destination?.forEach((destination)=>{
            const destinationElement = document.getElementById(destination);
            if (poiElement && destinationElement) {
                const { angle: angle } = this.calculateAngle(poiElement, destinationElement);
                this.directions.push({
                    destination: destination,
                    angle: angle
                });
            }
        });
    }
    calculateAngle(poiElement, destinationElement) {
        const poiRect = poiElement.getBoundingClientRect();
        const destinationRect = destinationElement.getBoundingClientRect();
        const poiCenterX = poiRect.left + poiRect.width / 2;
        const poiCenterY = poiRect.top + poiRect.height / 2;
        const destinationCenterX = destinationRect.left + destinationRect.width / 2;
        const destinationCenterY = destinationRect.top + destinationRect.height / 2;
        const dx = destinationCenterX - poiCenterX;
        const dy = destinationCenterY - poiCenterY;
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);
        return {
            angle: angle
        };
    }
    navigate(destination) {
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationStart, destination);
    }
}


class $b32024ef2ef1d9fa$export$d7007a7a50454967 {
    stockFor(poi) {
        let stock = this.byPoi.get(poi);
        if (!stock) {
            stock = new Map();
            this.byPoi.set(poi, stock);
        }
        return stock;
    }
    add(poi, item, quantity = 1) {
        const stock = this.stockFor(poi);
        stock.set(item, (stock.get(item) ?? 0) + quantity);
    }
    remove(poi, item, quantity = 1) {
        const stock = this.stockFor(poi);
        const next = (stock.get(item) ?? 0) - quantity;
        if (next > 0) stock.set(item, next);
        else stock.delete(item);
    }
    count(poi, item) {
        return this.byPoi.get(poi)?.get(item) ?? 0;
    }
    list(poi) {
        const stock = this.byPoi.get(poi);
        if (!stock) return [];
        return [
            ...stock.entries()
        ].map(([item, quantity])=>({
                item: item,
                quantity: quantity
            }));
    }
    constructor(){
        this.byPoi = new Map();
    }
}










// Fired by the narrator when a dialog node flagged `openMerchant` is entered.
// The merchant UI listens for this to open its sell/buy panel.
var $901c033196403010$export$de1ce4b59861d0ea;
(function(MerchantEventBus) {
    MerchantEventBus["open"] = "merchantOpen";
})($901c033196403010$export$de1ce4b59861d0ea || ($901c033196403010$export$de1ce4b59861d0ea = {}));


class $005bda2cd2699b64$export$64f1936845492eda {
    constructor(reader, stock){
        this.reader = reader;
        this.stock = stock;
        this.panel = document.querySelector(".js-merchant");
        this.list = document.querySelector(".js-merchant-items");
        this.close = document.querySelector(".js-merchant-close");
        this.tabs = document.querySelector(".js-merchant-tabs");
        this.currentPoi = null;
        this.activeTab = "sell";
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, (poi)=>this.currentPoi = poi);
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationStart, (poi)=>{
            this.currentPoi = poi;
            this.hide();
        });
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $901c033196403010$export$de1ce4b59861d0ea).open, ()=>this.open());
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $f5ff537df8440e15$export$af1a6ad62b6fae06).changed, ()=>{
            if (this.panel && !this.panel.hidden) this.render();
        });
        this.close?.addEventListener("click", ()=>this.hide());
        this.tabs?.addEventListener("click", (event)=>this.onTabClick(event));
        this.list?.addEventListener("click", (event)=>this.onListClick(event));
    }
    open() {
        if (!this.panel) return;
        this.activeTab = "sell";
        this.panel.hidden = false;
        this.render();
    }
    hide() {
        if (this.panel) this.panel.hidden = true;
    }
    coins() {
        return this.reader.getState().items.coins ?? 0;
    }
    owned(id) {
        return this.reader.getState().items[id] ?? 0;
    }
    onTabClick(event) {
        const tab = event.target.dataset.tab;
        if (!tab || tab === this.activeTab) return;
        this.activeTab = tab;
        this.render();
    }
    render() {
        if (!this.list) return;
        this.renderTabs();
        const rows = this.activeTab === "sell" ? this.sellRows() : this.buyRows();
        this.list.innerHTML = "";
        if (rows.length === 0) {
            const empty = document.createElement("div");
            empty.className = "merchant__empty";
            empty.textContent = this.activeTab === "sell" ? "Nothing to sell" : "Nothing to buy";
            this.list.appendChild(empty);
            return;
        }
        const table = document.createElement("table");
        table.className = "merchant__table";
        const head = document.createElement("tr");
        const cols = [
            [
                "\uD83D\uDCE6",
                "merchant__col-item",
                "Item"
            ],
            [
                "#",
                "merchant__col-qty",
                "Quantity"
            ],
            [
                "\uD83E\uDE99",
                "merchant__col-price",
                "Price"
            ],
            [
                "",
                "merchant__col-action"
            ]
        ];
        for (const [text, cls, title] of cols){
            const th = document.createElement("th");
            th.className = cls;
            th.textContent = text;
            if (title) th.title = title;
            head.appendChild(th);
        }
        const thead = document.createElement("thead");
        thead.appendChild(head);
        table.appendChild(thead);
        const tbody = document.createElement("tbody");
        for (const row of rows)tbody.appendChild(row);
        table.appendChild(tbody);
        this.list.appendChild(table);
    }
    renderTabs() {
        this.tabs?.querySelectorAll("[data-tab]").forEach((el)=>{
            el.classList.toggle("is-active", el.dataset.tab === this.activeTab);
        });
    }
    sellRows() {
        return Object.keys((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)).filter((id)=>(0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].sellable && ((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].price ?? 0) > 0 && this.owned(id) > 0).map((id)=>this.row(id, this.owned(id), "sell", true));
    }
    buyRows() {
        if (!this.currentPoi) return [];
        return this.stock.list(this.currentPoi).map(({ item: item, quantity: quantity })=>{
            const affordable = this.coins() >= ((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[item].price ?? 0) && (0, $c154c7fb9f805405$export$2f400479c9c17eaa)(this.reader.getState(), item);
            return this.row(item, quantity, "buy", affordable);
        });
    }
    row(id, quantity, action, enabled) {
        const tr = document.createElement("tr");
        tr.className = "merchant__item";
        const label = document.createElement("td");
        label.className = "merchant__label";
        label.textContent = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].name;
        const qty = document.createElement("td");
        qty.className = "merchant__qty";
        qty.textContent = String(quantity);
        const price = document.createElement("td");
        price.className = "merchant__price";
        price.textContent = (0, $3241912be5cdfff0$export$a17b3c2052469c69)((0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].price ?? 0);
        const actionCell = document.createElement("td");
        actionCell.className = "merchant__action-cell";
        const button = document.createElement("button");
        button.type = "button";
        button.className = "merchant__action";
        button.textContent = action === "sell" ? "Sell" : "Buy";
        button.setAttribute("data-action", action);
        button.setAttribute("data-item-id", id);
        button.disabled = !enabled;
        actionCell.appendChild(button);
        tr.append(label, qty, price, actionCell);
        return tr;
    }
    onListClick(event) {
        const target = event.target;
        const id = target.dataset.itemId;
        const action = target.dataset.action;
        if (!id || !action || !this.currentPoi) return;
        const price = (0, $98b8cfdab61b8cbb$export$17a1664ed1fb5d6f)[id].price ?? 0;
        if (price <= 0) return;
        if (action === "sell") {
            if (this.owned(id) <= 0) return;
            this.stock.add(this.currentPoi, id);
            (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).nodeEntered, {
                effects: [
                    {
                        type: "consume",
                        item: id,
                        quantity: 1
                    },
                    {
                        type: "grant",
                        item: "coins",
                        quantity: price
                    }
                ]
            });
        } else {
            if (this.coins() < price || !(0, $c154c7fb9f805405$export$2f400479c9c17eaa)(this.reader.getState(), id) || this.stock.count(this.currentPoi, id) <= 0) return;
            this.stock.remove(this.currentPoi, id);
            (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).nodeEntered, {
                effects: [
                    {
                        type: "consume",
                        item: "coins",
                        quantity: price
                    },
                    {
                        type: "grant",
                        item: id,
                        quantity: 1
                    }
                ]
            });
        }
    }
}





/**
 * Renders a tiny subset of markdown as safe HTML.
 *
 * Supports:
 *  - `**bold**` → `<strong>bold</strong>`
 *
 * HTML special characters in the input are escaped first, so the only HTML in
 * the output comes from this function's own transformations — the result is
 * safe to assign to `innerHTML` even with content of unknown origin.
 */ function $279cb0b34280c66e$export$cc4ce9acc1b1eb7b(text) {
    const escaped = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    return escaped.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
}






// Cadence of the trailing-dot loading animation used for delayed transitions.
const $a08dc11b7d43b491$var$LOADING_FRAME_MS = 400;
class $a08dc11b7d43b491$export$5329ba1a21d0689 {
    constructor(){
        this.currentOptions = [];
        this.titleElement = document.querySelector(".js-narrator-title");
        this.dialogElement = document.querySelector(".js-narrator-dialog");
        this.optionsElement = document.querySelector(".js-narrator-options");
        this.handleSelectedOptions();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, (poi)=>this.updateNarrator(poi));
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationStart, (poi)=>this.updateNarrator(poi));
    }
    handleSelectedOptions() {
        this.optionsElement.addEventListener("click", (event)=>{
            const optionElement = event.target;
            const indexAttr = optionElement.dataset.optionIndex;
            if (indexAttr === undefined) return;
            const option = this.currentOptions[Number(indexAttr)];
            if (!option) return;
            if (option.delayMs && option.delayMs > 0) {
                this.startDelayedTransition(option);
                return;
            }
            this.navigateTo(option);
        });
    }
    navigateTo(option) {
        const nextDialogId = typeof option.nextDialogId === "function" ? option.nextDialogId() : option.nextDialogId;
        this.renderNarrator(nextDialogId);
    }
    // Show a loading animation for `option.delayMs` before resolving and rendering
    // the next node. The `nextDialogId` function is evaluated AFTER the wait so it
    // reflects inventory at reveal time (e.g. fishing's full-bag release routing).
    startDelayedTransition(option) {
        this.clearPendingTransition();
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).dialogStart);
        this.currentOptions = [];
        this.resetOptions();
        this.startLoadingAnimation(option.loadingText ?? "Loading");
        this.castTimeout = setTimeout(()=>{
            this.castTimeout = undefined;
            this.stopLoadingAnimation();
            this.navigateTo(option);
        }, option.delayMs);
    }
    startLoadingAnimation(base) {
        let frame = 0;
        this.dialogElement.innerText = base;
        this.loadingInterval = setInterval(()=>{
            frame = (frame + 1) % 4;
            this.dialogElement.innerText = base + ".".repeat(frame);
        }, $a08dc11b7d43b491$var$LOADING_FRAME_MS);
    }
    stopLoadingAnimation() {
        if (this.loadingInterval !== undefined) {
            clearInterval(this.loadingInterval);
            this.loadingInterval = undefined;
        }
    }
    // Cancel any in-flight delayed transition (loader + timeout) without navigating.
    clearPendingTransition() {
        this.stopLoadingAnimation();
        if (this.castTimeout !== undefined) {
            clearTimeout(this.castTimeout);
            this.castTimeout = undefined;
        }
    }
    updateNarrator(poi) {
        // Navigating away mid-cast must cancel the pending reveal so its effects
        // never apply against a different narrator after the player leaves.
        this.clearPendingTransition();
        const narrator = this.fetchNarrator(poi);
        if (!narrator) {
            this.resetNarrator();
            return;
        }
        this.narrator = narrator;
        this.renderNarrator();
    }
    fetchNarrator(poiId) {
        const poi = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(poiId);
        if (!poi?.narratorId) return undefined;
        return (0, $c6f20a8aba11b3fc$export$b027244a9b92ba3d).find((n)=>n.id === poi.narratorId);
    }
    renderNarrator(dialogId = "start") {
        dialogId === "start" ? (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).narratorStart) : (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).dialogStart);
        const dialog = this.getDialog(dialogId);
        this.renderTitle(dialog);
        if (!dialog) {
            this.resetDialog();
            this.resetOptions();
            return;
        }
        if (dialog.effects && dialog.effects.length > 0) (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $c525691551415870$export$99f1f21fef99148b).nodeEntered, {
            effects: dialog.effects
        });
        if (dialog.openMerchant) (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $901c033196403010$export$de1ce4b59861d0ea).open);
        this.renderDialog(dialog);
        this.renderOptions(dialog);
    }
    getDialog(dialogId) {
        return this.narrator.dialog.find((option)=>option.id === dialogId);
    }
    renderTitle(dialog) {
        if (dialog?.type === (0, $c525691551415870$export$290cb7291ee58b61).description) {
            this.resetTitle();
            return;
        }
        this.titleElement.innerText = dialog?.name || this.narrator.name;
    }
    renderDialog(dialog) {
        this.dialogElement.innerHTML = (0, $279cb0b34280c66e$export$cc4ce9acc1b1eb7b)(dialog.text);
    }
    renderOptions(dialog) {
        this.resetOptions();
        this.currentOptions = [];
        if (!dialog.options) return;
        for (const option of dialog.options){
            if (option.condition && !option.condition()) continue;
            const index = this.currentOptions.length;
            this.currentOptions.push(option);
            const listElement = document.createElement("button");
            listElement.innerText = option.text;
            listElement.setAttribute("data-option-index", String(index));
            listElement.classList.add("option");
            const linkElement = document.createElement("li");
            linkElement.appendChild(listElement);
            const optionsElement = document.querySelector(".js-narrator-options");
            optionsElement.appendChild(linkElement);
        }
    }
    resetNarrator() {
        this.resetTitle();
        this.resetDialog();
        this.resetOptions();
    }
    resetTitle() {
        this.titleElement.innerText = "";
    }
    resetDialog() {
        this.dialogElement.innerText = "";
    }
    resetOptions() {
        this.optionsElement.innerHTML = "";
    }
}







class $2e3bb00949d76f97$export$c894e24133a9bea {
    constructor(){
        this.worldPOIs = (0, $7dc86ea3d04f3d15$export$f965ae91e38a1274);
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, (poi)=>this.initialiseMap(poi));
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationStart, (poi)=>this.navigationStart(poi));
    }
    static getInstance() {
        if (!$2e3bb00949d76f97$export$c894e24133a9bea.instance) $2e3bb00949d76f97$export$c894e24133a9bea.instance = new $2e3bb00949d76f97$export$c894e24133a9bea();
        return $2e3bb00949d76f97$export$c894e24133a9bea.instance;
    }
    initialiseMap(poi) {
        const poiData = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(poi);
        const mapId = poiData?.mapId ?? (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).startingMap;
        this.currentMapConfig = (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps.find((m)=>m.id === mapId) ?? (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps[0];
        this.mapElement = document.getElementById("map");
        this.applyBackgroundColor();
        // Create world container
        this.worldElement = document.createElement("div");
        this.worldElement.className = "map-world";
        this.worldElement.style.width = `${this.currentMapConfig.size[0]}px`;
        this.worldElement.style.height = `${this.currentMapConfig.size[1]}px`;
        // Create map image
        this.imageElement = document.createElement("img");
        this.imageElement.className = "map-world__image";
        this.imageElement.src = this.currentMapConfig.imagePath;
        this.imageElement.style.width = `${this.currentMapConfig.size[0]}px`;
        this.imageElement.style.height = `${this.currentMapConfig.size[1]}px`;
        // The map is the only <img>; without this a long-press on mobile offers to
        // save/download it. CSS -webkit-touch-callout covers iOS Safari, but Android
        // Chrome raises a contextmenu event that only preventDefault() suppresses.
        this.imageElement.draggable = false;
        this.worldElement.appendChild(this.imageElement);
        this.mapElement.addEventListener("contextmenu", (event)=>event.preventDefault());
        this.addMarkers();
        this.mapElement.appendChild(this.worldElement);
        if (poiData) {
            this.currentLocation = poi;
            this.centerMap(poi, false);
            this.highlightActiveMarker(poi);
        }
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $10b89994322a4ed4$export$290d4780f94d8760).mapChanged, this.currentMapConfig.id);
    }
    addMarkers() {
        const currentMapPOIs = this.worldPOIs.filter((p)=>p.mapId === this.currentMapConfig.id);
        // Lines are appended first so they sit behind the markers
        this.addConnectionLines(currentMapPOIs);
        // Remove existing markers
        this.worldElement.querySelectorAll(".map-world__marker").forEach((el)=>el.remove());
        currentMapPOIs.forEach(({ id: id, pos: pos })=>{
            const marker = document.createElement("div");
            marker.className = "map-world__marker";
            marker.style.left = `${pos[0]}px`;
            marker.style.top = `${pos[1]}px`;
            marker.innerHTML = `<div id="${id}" class="map-world__marker-dot"></div>`;
            this.worldElement.appendChild(marker);
        });
    }
    /**
   * Draws a thin white line between every linked pair of POIs on the current map.
   * Lines share the markers' coordinate space (the POI `pos` is used directly as
   * SVG coordinates), so they pan with the camera and align exactly with markers.
   */ addConnectionLines(currentMapPOIs) {
        const SVG_NS = "http://www.w3.org/2000/svg";
        // Remove existing overlay to avoid accumulation on rebuild
        this.worldElement.querySelector(".map-world__connections")?.remove();
        const onCurrentMap = new Set(currentMapPOIs.map((p)=>p.id));
        const posById = new Map(currentMapPOIs.map((p)=>[
                p.id,
                p.pos
            ]));
        const [width, height] = this.currentMapConfig.size;
        const svg = document.createElementNS(SVG_NS, "svg");
        svg.setAttribute("class", "map-world__connections");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        const seen = new Set();
        currentMapPOIs.forEach(({ id: id, pos: pos, destination: destination })=>{
            destination.forEach((targetId)=>{
                // Only connect POIs on the current map
                if (!onCurrentMap.has(targetId)) return;
                // Dedupe bidirectional links: one line per unordered pair
                const key = id < targetId ? `${id}|${targetId}` : `${targetId}|${id}`;
                if (seen.has(key)) return;
                seen.add(key);
                const targetPos = posById.get(targetId);
                if (!targetPos) return;
                const line = document.createElementNS(SVG_NS, "line");
                line.setAttribute("x1", `${pos[0]}`);
                line.setAttribute("y1", `${pos[1]}`);
                line.setAttribute("x2", `${targetPos[0]}`);
                line.setAttribute("y2", `${targetPos[1]}`);
                svg.appendChild(line);
            });
        });
        // Prepend so the overlay sits behind the markers
        this.worldElement.prepend(svg);
    }
    navigationStart(poi_ID) {
        if (!this.currentLocation) {
            console.error("Navigator not initialised with currentLocation");
            return;
        }
        if (!this.canNavigationStart(poi_ID)) {
            const newPoi = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(poi_ID);
            console.log("You can see", newPoi?.spotlight?.title, "in the distance.", newPoi);
            return;
        }
        this.currentLocation = poi_ID;
        // Check for portal (map transition)
        if (this.currentLocation.portal) {
            const { targetMap: targetMap, targetPOI: targetPOI } = this.currentLocation.portal;
            this.centerMap(poi_ID, true);
            setTimeout(()=>this.loadMap(targetMap, targetPOI), (0, $10b89994322a4ed4$export$d7dec8208a163e28));
            return;
        }
        this.emitNavigationEnd();
        this.centerMap(poi_ID);
        this.highlightActiveMarker(poi_ID);
    }
    loadMap(mapId, targetPOI) {
        const newMap = (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).maps.find((m)=>m.id === mapId);
        if (!newMap) {
            console.error("Map not found:", mapId);
            return;
        }
        this.currentMapConfig = newMap;
        this.applyBackgroundColor();
        this.imageElement.src = newMap.imagePath;
        this.worldElement.style.width = `${newMap.size[0]}px`;
        this.worldElement.style.height = `${newMap.size[1]}px`;
        this.imageElement.style.width = `${newMap.size[0]}px`;
        this.imageElement.style.height = `${newMap.size[1]}px`;
        this.addMarkers();
        this.currentLocation = targetPOI;
        this.centerMap(targetPOI, false);
        this.highlightActiveMarker(targetPOI);
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $10b89994322a4ed4$export$290d4780f94d8760).mapChanged, mapId);
        this.emitNavigationEnd();
    }
    applyBackgroundColor() {
        const nav = document.querySelector(".js-navigator");
        if (nav) nav.style.backgroundColor = this.currentMapConfig.backgroundColor ?? "";
    }
    centerMap(poi, animate = true) {
        const marker = this.worldPOIs.find((m)=>m.id === poi);
        if (!marker) return;
        const viewport = this.mapElement.getBoundingClientRect();
        const translateX = -(marker.pos[0] - viewport.width / 2);
        const translateY = -(marker.pos[1] - viewport.height * 0.72);
        // translate3d (not translate) keeps the pan on the GPU compositor on mobile
        // browsers that only reliably promote 3D transforms.
        const transform = `translate3d(${translateX}px, ${translateY}px, 0)`;
        if (!animate) {
            this.worldElement.style.transition = "none";
            this.worldElement.style.transform = transform;
            this.worldElement.offsetHeight; // force reflow
            this.worldElement.style.transition = "";
        } else this.worldElement.style.transform = transform;
    }
    highlightActiveMarker(activeId) {
        this.worldPOIs.forEach(({ id: id })=>{
            const el = document.getElementById(id);
            if (el) el.classList.toggle("is-active", id === activeId);
        });
    }
    canNavigationStart(poi_ID) {
        return this.currentLocation.destination.includes(poi_ID);
    }
    emitNavigationEnd() {
        setTimeout(()=>{
            (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationEnd, this.currentLocation.id);
        }, (0, $10b89994322a4ed4$export$d7dec8208a163e28));
    }
    set currentLocation(poi) {
        if (typeof poi === "string") {
            const newPoi = (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(poi);
            if (newPoi) this._currentLocation = newPoi;
            else {
                console.error("POI", poi, "not found");
                return;
            }
        } else this._currentLocation = poi;
    }
    get currentLocation() {
        return this._currentLocation;
    }
}






class $9dba4cbc021d25cd$export$1033c28b5e1c2deb {
    constructor(){
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $22d95350298e069a$export$219d5638b1da6603).initialise, (poi)=>this.updateSpotlight(poi));
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).on((0, $10b89994322a4ed4$export$290d4780f94d8760).navigationStart, (poi)=>this.updateSpotlight(poi));
    }
    static getInstance() {
        if (!$9dba4cbc021d25cd$export$1033c28b5e1c2deb.instance) $9dba4cbc021d25cd$export$1033c28b5e1c2deb.instance = new $9dba4cbc021d25cd$export$1033c28b5e1c2deb();
        return $9dba4cbc021d25cd$export$1033c28b5e1c2deb.instance;
    }
    updateSpotlight(poi) {
        const spotlight = this.fetchSpotlight(poi);
        if (!spotlight) {
            this.clearSpotlight();
            return;
        }
        this.renderTitle(spotlight.title);
        this.renderDescription(spotlight.description);
    }
    clearSpotlight() {
        this.renderTitle("");
        this.renderDescription("");
    }
    renderTitle(title) {
        const titleElement = document.querySelector(".js-spotlight-title");
        titleElement.innerText = title;
    }
    renderDescription(description) {
        const descriptionElement = document.querySelector(".js-spotlight-description");
        descriptionElement.innerText = description || "";
    }
    fetchSpotlight(poi) {
        return (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(poi)?.spotlight;
    }
}



class $340b14df1cbd173d$export$dc18c479cc0c8e18 {
    constructor(){
        const autosave = (0, $4f0cb90897ee070c$export$61e9caf654e23bd2).getInstance();
        const inventory = (0, $73473c2d2f75563d$export$a033e390692f359f).init(new (0, $817acb2f43511c23$export$ea74da9b5c8c37e4)(autosave));
        new (0, $2e3bb00949d76f97$export$c894e24133a9bea)();
        new (0, $9dba4cbc021d25cd$export$1033c28b5e1c2deb)();
        new (0, $d5d235cae94184b7$export$9d532498ede20ce1)();
        new (0, $a08dc11b7d43b491$export$5329ba1a21d0689)();
        new (0, $de4762133797aa2a$export$b68637424d278e7c)(inventory);
        new (0, $b54f58e47b08eeb3$export$fe8a79e1b6b59a8c)(inventory);
        new (0, $8701a593c206eaf6$export$67348c0c68d77a13)(inventory);
        new (0, $005bda2cd2699b64$export$64f1936845492eda)(inventory, new (0, $b32024ef2ef1d9fa$export$d7007a7a50454967)());
        new (0, $cca8b0afb9b18424$export$b3c44ac484b3c461)();
        const starterPOI = (0, $6528f9074d7b564d$export$b9c5bbe98d67049c).startingPOI;
        const autoSaveCurrentPOI = autosave.currentPOI;
        // Fall back to starter if autosaved POI no longer exists
        const currentPOI = autoSaveCurrentPOI && (0, $29dbe5dc0c1244c4$export$2105e595f0c02dae)(autoSaveCurrentPOI) ? autoSaveCurrentPOI : starterPOI;
        (0, $eeb13d182ec6db0f$export$2e2bcd8739ae039).emit((0, $22d95350298e069a$export$219d5638b1da6603).initialise, currentPOI);
    }
}



new (0, $340b14df1cbd173d$export$dc18c479cc0c8e18)();


//# sourceMappingURL=index.6916bdf4.js.map
